const SPANISH_TRANSLATION = {
  home: {
    confront: {
      title: `CONFRONTE SUS DATOS`,
      title_2: "Y VÉALOS EN DASHBOARD            ",
      section_text_1:
        "¿Parece imposible analizar y gestionar todos los datos y reglas de negocio de su empresa? Los dashboards inteligentes son soluciones simples y asertivas para ayudar a controlar y monitorear los procesos financieros, mejorando la calidad de la información, reduciendo costos y previniendo vulnerabilidades.",
      section_text_2:
        "14 días de prueba gratis. No se necesita tarjeta de crédito.",
    },
    business_assurance_section: {
      title: `SOMOS UNA PLATAFORMA DE ASEGURAMIENTO DE NEGOCIOS`,
      section_text: `Conecte cualquier forma de fuente de datos en una única fuente de datos y cree dashboards atractivos e interactivos, donde puede compartir automáticamente con sus empleados, proveedores y clientes. Mira nuestro video. Obtenga más información sobre Hyaia y lo que podemos hacer.`,
    },
    who_we_are: {
      title: "QUIENES SOMOS",
      section_text_1: `Somos una empresa enfocada en la recuperación y garantía de ingresos, a través de la consultoría y la tecnología, tenemos como objetivo brindarle al cliente una mayor eficiencia financiera y operativa en los negocios, además de identificar y tratar posibles irregularidades (fraudes y pérdidas).`,
      section_text_2: `Con un trato personalizado a nuestros clientes, nos hemos convertido en un referente en las áreas de telecomunicaciones, retail, industria y salud. Contamos con un equipo calificado capaz de identificar demandas y brindar los mejores resultados para su negocio, utilizando una tecnología única con un alto grado de procesamiento.`,
      section_text_3: `Actualmente estamos presentes en la vida de miles de personas. Como nuestros clientes, los ayudamos en su camino hacia la evolución digital, a través de consultoría o desarrollo de soluciones, brindando servicios con calidad y compromiso.`,
    },
    hyaia_gathers: {
      title: `HYAIA REÚNE EN UN SOLO PRODUCTO HERRAMIENTAS QUE DISPONIBILIZAN RECURSOS FLEXIBLES GARANTIZANDO AUTONOMÍA AL ÁREA DE NEGOCIO`,
    },
    for_whom: {
      business_man: {
        title: "PARA EMPRESÁRIOS",
        section_text:
          "Mejor calidad de datos para la toma de decisiones                ",
      },
      business_architects: {
        title: "PARA ARQUITECTOS DE EMPRESA                ",
        section_text: "Revolución en BA & BI integrado                ",
      },
      consultants: {
        title: "PARA CONSULTORES",
        section_text: "Aumenta tu oferta de servicios                ",
      },
    },
    differential: {
      title: "¿CUÁL ES NUESTRO DIFERENCIAL?            ",
      section_text:
        "Hyaia hace que Business Revenue Assurance sea fácil para cualquier línea de negocio o segmento de negocio. Nuestra tecnología ágil e innovadora permite una visión completa de todo lo que sucede en las cadenas operativas y financieras de sus proyectos. Esto permite un análisis mejor, más rápido y más inteligente para la toma de decisiones. Mantener el Data Lake como único punto de autenticidad.",
    },
    how_it_works: {
      title: "COMO FUNCIONA?",
    },
    step1: {
      title: "CONEXIÓN DE DATOS FÁCIL",
      section_text:
        "Conexión sencilla a cualquier base de datos, independientemente del formato.            ",
    },

    step2: {
      title: "APLICACIÓN Y TRAMITACIÓN DE LAS REGLAS DE NEGOCIO",
      section_text:
        "Una vez conectado, todas las políticas, estrategias y reglas comerciales operativas y financieras se ingresan en la plataforma y se aplican a la base de datos.",
    },

    step3: {
      title: "RESULTADO EN DASHBOARDS & WORKFLOWS",
      section_text:
        "Cada irregularidad, pérdida financiera, exposición al riesgo y desempeño se presentan en dashboards y workflows.",
    },

    step4: {
      title: "ANÁLISIS DE DATOS Y TOMA DE DECISIONES",
      section_text:
        "Con los resultados ofrecidos en tiempo real o casi real, tus decisiones serán más acertadas y asertivas, aumentando tus ganancias.",
    },

    lets_start: {
      title: "¿VAMOS A EMPEZAR?            ",
      section_text: `Comience a rastrear su negocio de principio a fin.            `,
    },
  },
  suport: {
    title: "DESARROLLAR E INTEGRAR        ",
    section_text:
      "Aplique algoritmos de Machine Learning directamente desde su base de datos. Agregue dashboards a portales y aplicaciones móviles o agregue integración en tiempo real a cualquier sistema externo.",
    list_api_advantages: {
      api_advantages: {
        title: "¿CUÁLES SON LAS VENTAJAS DE UNA API?                ",
        section_text:
          "¡Incontable! Las API (Application Program Interface) permiten gestionar la mayoría de las funciones de Hyaia a través de su propia aplicación.",
      },

      mobile_apps: {
        title: "DESARROLLAR APLICACIONES MÓVILES                ",
        section_text_1:
          "¿Quiere tener su propia aplicación móvil para informes y cuadros de mando, con su marca o logotipo?",
        section_text_2:
          "A través de nuestros Live Links y API, puede crear y exhibir su aplicación móvil en todas las plataformas principales.",
        section_text_3:
          "Agregue un módulo de informe completo a su aplicación móvil en momentos.                ",
      },

      dashboards: {
        title: "SALPICADERO INCORPORADO                ",
        section_text_1:
          "Con nuestros Live Links y API, puede crear e integrar directamente en sus aplicaciones web.",
        section_text_2:
          "Pase sus parámetros y seguridad, y realice interacciones que los lleven directamente a la aplicación principal.",
      },
    },

    list_data: {
      realtime_data: {
        title: "DATOS EN TIEMPO REAL                ",
        section_text_1:
          "Tan pronto como lleguen nuevos datos, podrá verlos, al mismo tiempo, en nuestros dashboards a través de nuestra API.",
        section_text_2:
          "Nuestras API son excelentes para monitorear nueva información, procesos y reglas en ventas, tickets de soporte, IoT y muchos otros elementos críticos, en tiempo real.",
      },
      data_management: {
        title: "GESTIONA TUS DATOS                ",
        section_text:
          "Controla tu información a través de tus aplicaciones a través de nuestras APIs. Cree un centro de control automatizado para actualizaciones y adiciones de datos. Gestión de horarios: seguimiento, activación o pausa de los mismos.",
      },
      interactive: {
        title: "HAZLO INTERACTIVO                ",
        section_text:
          "Agregue filtros y análisis dinámicos para que sus usuarios manipulen los dashboards y accedan a las respuestas a sus preguntas comerciales. Filtrar datos por equipo o usuario.",
      },
      process_automation: {
        title: "PROCESOS AUTOMATIZADOS                ",
        section_text:
          "Programar publicaciones y alertas. Desarrollamos estratégicamente todas las actualizaciones de datos y la distribución del tablero para usted.",
      },
    },
    want_know_more: {
      title: "¿QUIERES MÁS INFORMACIÓN?                ",
      section_text:
        "Póngase en contacto con nuestro equipo técnico y aprenda cómo autorizar, referenciar y usar nuestros puntos finales de API.",
    },
  },
  modules: {
    title: `CONOCE NUESTROS MÓDULOS`,
    subtitle_desc: `Descubre lo que la mejor y única tecnología multimercado del mundo, en Business Revenue Assurance, puede hacer por ti.`,
    audit_text_1: `Audita el 100% de tu base de datos y encuentra todos los incumplimientos y pérdidas financieras en tu negocio.`,
    audit_text_2: `Contar con reportes precisos y confiables, en tiempo real, para la toma de decisiones que resuelvan oportunamente sus adversidades.`,
    fraud_text: `Localiza, en tiempo real, cualquier condición de fraude en tu negocio. Hyaia es el mejor y más moderno sistema antifraude. Garantizando agilidad y precisión en la detección de irregularidades.`,
    compliance_text: `El gobierno corporativo de tu negocio se lleva a cabo mediante Inteligencia Artificial, en tiempo real. No pierda certificaciones ni reciba multas por incumplimiento. Hyaia es el mejor controlador que su empresa puede tener.`,
    indicator_text_1: `Un generador de KPI y OKR creados a partir de los datos auditados.`,
    indicator_text_2: `Compara tus indicadores a través de los resultados que muestra el INDICADOR.`,
    dashboard_text: `Sus informes de auditoría, fraude, discrepancias y exposición al riesgo en dashboards interactivos. Con un diseño moderno para una toma de decisiones rápida y crucial.`,
    chatbot_text: `Robots interactivos para un mejor monitoreo, alertas y notificaciones sobre tus procesos, reglas y políticas corporativas.`,
    analysis_text_1: `Una tecnología revolucionaria, en Deep Learning, para afinar procesos, reglas y anticipar problemas, que reducen tus márgenes de beneficio.`,
    analysis_text_2: `Más vale prevenir que curar, este módulo analiza e indica el camino para el futuro de tu negocio, con un alto porcentaje de éxito.`,
    bigdata_text_1: `Tus datos organizados, centralizados y convertidos en información clara y de calidad.`,
    bigdata_text_2: `Lo mejor en tecnología Big Data está en Hyaia.        `,
    machine_learn_text_1: `Un módulo revolucionario en la comprensión y el aprendizaje de su negocio.        `,
    machine_learn_text_2: `Con cada proceso, regla o política corporativa, Machine Learning de Hyaia aprende y memoriza lo que se enseña. No se requiere reentrenamiento o reemplazo del usuario.`,
    scheduler_text_1: `Un programador personalizable para sus auditorías de datos, sobre sus reglas y procesos.`,
    scheduler_text_2: `Auditoría todo el tiempo o en periodos determinados, tú decides lo que más te conviene en tu tiempo y necesidad.`,
    workflow_text_1: `Recibe alertas, en escalabilidad, de todas las ejecuciones auditadas en tu base.        `,
    workflow_text_2: `Sepa qué reglas, procedimientos o políticas corporativas incumplidas serán notificadas instantáneamente hasta que se resuelva el problema.`,
    security_text_1: `Garantice la protección total de su auditoría.        `,
    security_text_2: `La seguridad inspecciona y monitorea a cada usuario de la tecnología, mostrando informes de quién realizó los accesos y cuáles fueron sus acciones. Incluso desactivando alguna función o regla de auditoría de herramientas.`,
    security_text_3: `Su negocio está protegido en todo momento.`,
  },
  buttons: {
    demo_btn_text: "Obtener una prueba gratuita",
    demo_btn_alternative_text_1: "Acceso Gratis        ",
    demo_btn_alternative_text_2: "PRUEBA GRATIS        ",
    more_btn_text: " Más información",
    contact_us_text: "Fale Conosco!",
  },

  examples: {
    title: "VER SOBRE EL DESEMPEÑO DE HYAIA EN MULTISECTORES",
    section_text:
      "Descubre un poco de lo que la mejor tecnología en Business Revenue Assurance puede hacer por tu empresa.",
    telecom_sector: {
      billing_policy: {
        title: "BILLING POLICY ASSURANCE: ",
        section_text: "VALIDACIÓN DEL PROCESO DE FACTURACIÓN POST PAGO",
        needs: {
          title: "Demanda:                    ",
          section_text_1: "Análisis de facturas por año.                    ",
          section_text_2:
            "Mapa de cobertura de control aumentado.                    ",
          section_text_3:
            "Reducción de costes por factura.                    ",
        },
        solutions: {
          title: "Solución:                    ",
          section_text:
            "Despliegue de nuestra tecnología para el Billing Policy Assurance.",
        },
        results: {
          title: "Resultados:",
          section_text_1: "Descenso en el Ranking Procon.",
          procon_text: "",
          section_text_2:
            "Enfoque del equipo en el manejo de excepciones.                    ",
          section_text_3: "Reducción de costos operativos.                    ",
        },
      },

      charging_policy: {
        title: "CHARGING POLICY ASSURANCE: ",
        section_text: "VALIDACIÓN DEL PROCESO DE COBRO PREPAGO",
        needs: {
          title: "Demanda:                    ",
          section_text_1:
            "Análisis tarifa minutos promocionales.                    ",
          section_text_2:
            "Análisis de elegibilidad del cliente x promociones.                    ",
          section_text_3:
            "Medición del impacto financiero de las divergencias.                    ",
        },
        solutions: {
          title: "Solución:",
          section_text:
            "Implementación de nuestra tecnología para Charging Policy Assurance.                    ",
        },
        results: {
          title: "Resultados:",
          section_text_1: "100% análisis de clientes.                    ",
          section_text_2: "Reducción del 80% en el tiempo de proceso.",
          section_text_3:
            "Ejecución del proceso con el 10% del headcount.                    ",
        },
      },
    },

    health_sector: {
      title: "SALUD",
      section_text: "",
      cost_policy: {
        title: "COST POLICY ASSURANCE: ",
        section_text: "ANÁLISIS DE COSTOS DE LOS PROCEDIMIENTOS GESTIONADOS.",
        needs: {
          title: "Demanda:",
          section_text_1:
            "Evaluación del 100% de los trámites gestionados.                    ",
          section_text_2:
            "Análisis de costo y margen de trámites.                    ",
          section_text_3:
            "Identificación de incumplimiento del protocolo.                    ",
        },
        solutions: {
          title: "Solución:",
          section_text:
            "Implementación de nuestra tecnología para Cost Policy Assurance.                    ",
        },
        results: {
          title: "Resultados:",
          section_text_1:
            "Análisis del 100% de protocolos gestionados.                    ",
          section_text_2: "Análisis en línea de trámites.                    ",
          section_text_3:
            "Ganancia de escala de análisis de costos.                    ",
        },
      },

      policy_assurance: {
        title: "MEDICAL PROTOCOL POLICY ASSURANCE: ",
        section_text:
          "ANÁLISIS DE DESVIACIÓN EN LA PRÁCTICA MÉDICA.                ",
        needs: {
          title: "Demanda:",
          section_text_1:
            "Aplicar inteligencia analítica a la información de asistencia.                    ",
          section_text_2:
            "Identificar y estandarizar el perfil de consumo en las prácticas médicas.                    ",
          section_text_3:
            "Identificar desviaciones en el estándar de atención médica.                    ",
        },
        solutions: {
          title: "Solución:",
          section_text:
            "Despliegue de nuestra tecnología para Medical Protocol Policy Assurance.",
        },
        results: {
          title: "Resultados:",
          section_text_1:
            "Análisis del 100% de citas médicas.                   ",
          section_text_2:
            "Reducción de costos y vista detallada de infractores.                    ",
          section_text_3:
            "Mejora de la comunicación del alineamiento estratégico del hospital.                    ",
        },
      },
    },

    retail_sector: {
      title: "VENTA MINORISTA            ",
      section_text: "",
      crm_policy: {
        title: "CRM POLICY ASSURANCE:",
        section_text:
          "VALIDACIÓN DEL PROCESO DE FIDELIZACIÓN DE CLIENTES .               ",
        needs: {
          title: "Demanda:",
          section_text:
            "Validar el otorgamiento de descuentos en base a la estrategia de fidelización.                    ",
        },
        solutions: {
          title: "Solución:",
          section_text:
            "Implementación de nuestra tecnología para CRM Policy Assurance.                    ",
        },
        results: {
          title: "Resultados:",
          section_text_1:
            "Análisis del 100% de las transacciones de compra de productos.",
          section_text_2:
            "Reducción de pérdidas por otorgamiento indebido de descuentos.",
          section_text_3:
            "Reducción del 90 % en el tiempo de análisis de transacciones.",
        },
      },

      logistics_policy: {
        title: "LOGISTIC POLICY ASSURANCE:  ",
        section_text: "VALIDACIÓN DEL PROCESO DE DISTRIBUCIÓN DE MEDICAMENTOS.",
        needs: {
          title: "Demanda:",
          section_text_1:
            "Evaluación del proceso de distribución de productos.                    ",
          section_text_2:
            "Analizar y comparar órdenes de compra y flujo de entrega de productos.                    ",
        },
        solutions: {
          title: "Solución:",
          section_text:
            "Implementación de nuestra tecnología para Logistic Policy Assurance.                    ",
        },
        results: {
          title: "Resultados:",
          section_text_1:
            "Análisis del 100% de las órdenes de compra de producto.                    ",
          section_text_2:
            "Análisis del proceso de distribución.                    ",
          section_text_3:
            "Ganancia en productividad y mayor eficiencia en la operación.                    ",
        },
      },
    },

    know_more: {
      title: "¿QUIERES SABER MÁS?            ",
      section_text:
        "Ponte en contacto con nuestro equipo comercial. Y descubra cómo resolver sus inquietudes comerciales con Hyaia.",
    },
  },

  realtime_data: {
    title: "DATOS EN TIEMPO REAL        ",
    section_text_1:
      "Actualizar tus datos minuto a minuto es primordial, pero ser más rápido a veces es más de lo necesario.",
    section_text_2:
      "¡Hyaia tiene API que pueden desencadenar actualizaciones en sus bases de datos o usar directamente nuestras API para agregar y actualizar sus últimas filas de datos al instante.",
    what_is: {
      title: "¿QUÉ SON LOS DATOS EN TIEMPO REAL?",
      section_text_1:
        "Es información disponible inmediatamente después de ser encuestada o asignada.",
      section_text_2:
        "El retraso es prácticamente nulo entre el momento en que se crea y el momento en que se ve en tu dashboard.",
    },
    apis_and_webhooks: {
      title: "API Y WEBHOOKS",
      section_text_1:
        "Desarrolle, envíe, actualice o elimine reglas comerciales, políticas estratégicas y operativas, en tiempo real o casi real, en su cadena de procesos.",
      section_text_2:
        "A través de nuestros terminales de datos, puede tener el control total de sus grupos de datos y presentar sus cuadros de mando hasta la próxima información.",
      section_text_3:
        "Con nuestros puntos finales de datos REST, puede tomar posesión de sus conjuntos de datos y mostrar sus dashboards hasta la segunda información.",
      section_text_4:
        "Aplique nuestros módulos de AUDIT y WORKFLOW para verificar sus datos y detectar incumplimiento, incumplimiento de reglas, fraude y rendimiento en sus dashboards.",
    },

    triggers: {
      title: "ACTIVADORES DE ACTUALIZACIÓN DE DATOS",
      section_text_1:
        "Habilite actualizaciones de datos, cargas de datos parciales o completas, cualquier ocurrencia fuera de Hyaia con nuestras conexiones de puntos finales de API.",
      section_text_2:
        "Configure su agrupación de datos o fuentes, y actívelas según las demandas en función de cualquier ocurrencia, sus aplicaciones o acciones de los usuarios.",
    },

    notifications: {
      title: "ALERTAS Y NOTIFICACIONES",
      section_text_1:
        "A través del módulo WORKFLOW, puede desarrollar aplicaciones móviles e innovadoras para la Web que realizan notificaciones y alertas inmediatas, mostrando dashboards de gestión en tiempo real.",
      section_text_2: "Con nuestro “SCHEDULER” puedes llamar a APIs externas.",
    },

    data_push_and_pull: {
      title: "DATA PUSH AND PULL",
      section_text:
        "Envíe datos en tiempo real (push) o active una actualización de datos (pull) y deje que Hyaia recopile sus datos como elija.",
    },

    send_data: {
      title: "ENVIAR DATOS EN TIEMPO REAL            ",
      section_text_1:
        "Con la ayuda de los extremos de la API de Hyaia, puede transferir datos desde cualquier cliente, aplicación u otras herramientas de integración en tiempo real.",
      section_text_2:
        "Una nueva información es agregada a una hoja de cálculo o su CRM, y puede verificar instantáneamente, en sus dashboards, y visualizar las devoluciones.",
    },
    load_data: {
      title: "CARGA DE DATOS EN TIEMPO REAL            ",
      section_text_1:
        "Si sus aplicaciones no pueden enviar datos a través de nuestra API, pueden informar a Hyaia para obtener los datos. En lugar de enviar su información a Hyaia, enviará una notificación para acceder a datos de numerosas fuentes y actualizar sus dashboards.",
      section_text_2:
        "Ágil, intuitivo y fácil de implementar, Hyaia hace todo el trabajo.            ",
    },
  },

  data_management: {
    title: "GESTIÓN DE DATOS HECHA FÁCIL        ",
    section_text:
      "Concilia, confronta, audita, limpia, fusiona tus datos con Hyaia, en su plataforma ETL, práctica y fácil de usar.",
    reconcile: {
      title: "MUCHO MÁS QUE VISUALIZACIÓN DE DATOS, UNA HERRAMIENTA ETL",
      section_text_1:
        "Una vez que Hyaia está conectada a sus bases de datos, su empresa está lista para convertir los datos en información útil. Hyaia es una fuente de datos poderosa, capaz de limpiar, conciliar, confrontar, estandarizar, enriquecer y combinar innumerables fuentes de datos.",
      section_text_2: "",
      section_text_3:
        "¿Necesita una columna auditada de que su fuente de información todavía está llena de no conformidades? Desarrolle en Hyaia y cada vez que se actualicen sus datos, las auditorías también se actualizarán.",
      section_text_4:
        "¿Quizás necesita información agrupada de una manera específica? Cree una agrupación en Hyaia y siempre estará sincronizada y disponible de inmediato para verla en sus dashboards.",
    },

    datasource: {
      title: "DATOS SANITIZADOS            ",
      section_text_1:
        "Organizar su información para usarla en dashboards no siempre es sencillo. Conseguir que todos tus datos estén uniformes y listos para ser visualizados, en una hoja de cálculo o gráfica, es una tarea ardua y requiere mucha intervención manual de información.",
      section_text_2:
        "Hyaia aborda estas inquietudes con nuestras herramientas de estandarización y desinfección de datos. Nuestro módulo Big Data garantiza que todos sus datos de texto estén en el caso correcto, sin espacios adicionales o que sus fechas no estén en 1719 o 2399. Este módulo de Machine Learning permite que todos los valores no conformes se conviertan en uno, por ejemplo “US”, “U.S.” e “USA”,, que se puede convertir automáticamente a “Estados Unidos”.",
    },

    agile_connection: {
      title: "CONCILIAR, FUSIONAR Y COMBINAR DATOS            ",
      section_text_1:
        "¿Tiene la necesidad de hacer coincidir sus objetivos de ventas con sus cifras de ventas actuales? ¿Imagina conectar datos pasivos a datos de salida? Nuestras herramientas Hyaia Audit, Machine Learning, Big Data le permiten reconciliar y combinar información de múltiples fuentes en una sola hoja de cálculo.",
      section_text_2:
        "Todos los elementos combinados permanecen sincronizados con los grupos individuales de información, por lo que no tiene que volver a coincidir. Simplemente actualice cada fuente de datos individual y se rectificará el conjunto de información. ",
    },

    data_integrity: {
      title: "TRANSFORMAR DATOS            ",
      section_text:
        "El módulo de análisis le permite usar reglas comerciales familiares, políticas estratégicas y operativas, para crear ajustes o nuevos pedidos. Autorizando a Hyaia para analizar sus bases de datos, sin tener que cambiar sus datos originales.",
    },

    merge_data: {
      title: "COMBINAR DATOS            ",
      section_text_1:
        "Examine los mismos aspectos en múltiples equipos, sistemas y geografías, y reúnalos en un grupo de datos. Hazlo de forma económica y automática con nuestra combinación de datos.",
      section_text_2:
        "Hyaia representa hechos que permiten a cada usuario final respaldar su propio contenido de la manera que elija y privada. Puedes unir datos para crear cuadros de mando diferenciados y completos.",
    },

    easy_integration: {
      title: "FÁCIL INTEGRAÇÃO",
    },

    cloud_or_onpremise: {
      title: "¿DÓNDE ESTÁN TUS DATOS?            ",
      cloud: {
        title: "¿EN LA NUBE?                ",
        section_text:
          "No hay problema, somos una herramienta SaaS y hacemos conexiones directamente a su Nube.",
      },

      onpremise: {
        title: "EN TU INFRAESTRUCTURA?                ",
        section_text:
          "Nos conectamos físicamente a su base de datos o servidores, promoviendo resultados casi en tiempo real.",
      },
    },
  },

  datasources: {
    title: "DATA SOURCES    ",
    section_text:
      "Combine y compare todos los datos de su organización en un solo lugar, garantizar consistencia y calidad en los datos con agilidad y facilidad de generar indicadores, como cuadros de mando e informes.",
    reconcile: {
      title: "CONCILIAR, CONFRONTAR Y SANEAR SUS DATOS EN UN SOLO LUGAR",
      section_text:
        "Trabajé con Hyaia para unificar su lectura y auditoría de datos en un solo lugar. Cree interoperabilidad entre diferentes conjuntos de datos y diferentes sistemas con los que trabajar. Impute sus aplicaciones externas, como R y SPSS, para un análisis profundo y acertado de su información.            ",
    },

    datasource: {
      title: "BENEFICIOS DE UNA DATA SOURCE   ",
      section_text_1:
        "Avalie a imagem e classificação externas da sua empresa através da Hyaia.",
      section_text_2:
        "Totalmente fácil de usar e intuitivo, o nosso assistente de conexão de dados te orientará a conectar as suas contas de mídias sociais e analisa-las em minutos.",
    },

    agile_connection: {
      title: "CONEXIÓN ÁGIL            ",
      section_text:
        "Hyaia dispone de tecnología única, lenguaje propio de 4ª generación, alta potencia digital y conexión a cualquier tipo de fuente de datos. Brinda acceso, en tiempo real o casi real, al análisis de todos los parámetros de su empresa. Asegurando una respuesta rápida sea cual sea la adversidad que consuma su margen de beneficio.",
    },

    data_integrity: {
      title: "INTEGRIDAD DE LOS DATOS            ",
      section_text:
        "A través de nuestras tecnologías, en Big Data, la calidad e integridad de sus datos será cada vez más profunda y totalitaria. Mostrando el origen, razón y cumplimiento cualquiera que sea la información.",
    },

    easy_integration: {
      title: "FÁCIL INTEGRACIÓN            ",
      section_text_1:
        "Independientemente de su sistema, aplicación, plataforma, base de datos o API, desde un complejo ERP o CRM hasta un archivo txt, Hyaia logra integrar información de cada uno de ellos simultáneamente.",
      section_text_2:
        "Disminuyendo la no interoperabilidad, fomentando la conciliación, el enfrentamiento y la aplicación integral de las reglas de negocio y políticas corporativas en su empresa.",
    },
  },

  interactive_dashboards: {
    smart_dashboards: {
      title: "DASHBOARDS INTERACTIVOS E INTELIGENTES            ",
      section_text:
        "Transforme sus datos en información quirúrgica con nuestros dashboards inteligentes y tome decisiones asertivas para su negocio.",
    },
    fully_interactive: {
      title: "DASHBOARDS TOTALMENTE INTERACTIVOS",
      section_text_1:
        "Con solo un clic, incorpore información de referencia cruzada con detalles en sus gráficos, KPI y tablas. Muestre subtablas y numerosos dashboard. Expanda y contraiga gráficos o cambie escalas de tiempo. Agrupar por meses, semestres o años.",
      section_text_2:
        "Para garantizar un excelente flujo de información, las interacciones son clave para que sean interesantes.",
    },
    click_and_filter: {
      click: {
        title: "HAGA CLIC Y FILTRO                ",
        section_text_1:
          "Elija una columna de un gráfico de barras y filtre la hoja de trabajo junto a ella. Seleccione un indicador y vaya a otro tablero, con más información al respecto.",
        section_text_2:
          "Haga clic en una fila en una hoja de trabajo y exponga todo el tablero. Visualiza todo fácilmente configurable a través de la pestaña de interacciones, a través de las manifestaciones de cada widget.",
      },
      users_and_teams: {
        title: "PAR METROS DE EQUIPO Y USUARIOS                ",
        section_text_1:
          "¿Cuál es tu necesidad? 4 dashboards? ¿Uno por cada nivel jerárquico de su organización o por sector liberado, según la regla de acceso de cada usuario?",
        section_text_2:
          "Defina los parámetros de cada usuario en la propia plataforma y controle sus gráficos, según la necesidad y el lanzamiento de cada usuario.",
      },
      table: {
        title: "TABLAS DE MEJORA                ",
        section_text_1:
          "A través de nuestras hojas de trabajo de desglose y widgets funcionales, profundice en cualquier grupo de datos, mientras mantiene los resúmenes de nivel avanzado claros y disponibles.",
        section_text_2:
          "No es necesario configurar nada, simplemente arrastrar y soltar.                ",
      },
      easy_nav: {
        title: "NAVEGAR FÁCILMENTE",
        section_text_1:
          "Desarrolle su navegación entre dashboards, aplicaciones externas, sitios web, videos e imágenes.",
        section_text_2:
          "Utiliza menús con botones, grupos de botones, gráficos, imágenes e indicadores.                ",
        section_text_3:
          "Muestre una historia de datos más sofisticada desarrollando un seguimiento de sus métricas.",
      },
    },
    easiest_tool: {
      title: "UNA HERRAMIENTA MÁS FÁCIL E INTELIGENTE PARA INFORMAR",
      section_text_1:
        "Hyaia puede informar cuando hay desviaciones del desempeño en sus reglas, procesos y políticas operativas.",
      section_text_2:
        "Aproveche su tiempo para crear clientes potenciales y gaste menos energía en hojas de cálculo.",
    },
  },

  partners: {
    title: "ASOCIACIONES",
    section_text:
      "Trabajamos con socios líderes en el mercado en tecnología e innovación, y entendemos que las relaciones ayudan a aumentar nuestro nivel de competitividad.",
  },

  reports: {
    title: "INFORMES EN LA PALMA DE TU MANO        ",
    section_text_1:
      "Obtenga acceso a los informes de su empresa en la palma de su mano en tiempo real o casi en tiempo real.",
    section_text_2:
      "Hyaia le permite acceder a su información desde cualquier lugar con nuestros dashboards inteligentes.        ",
    access_form: {
      title: "ACCEDE DONDE ESTÉS            ",
      section_text_1:
        "Instale la aplicación para iOS o Android y vea sus dashboards en todas partes.            ",
      section_text_2:
        "Totalmente receptivos, nuestros dashboards se adaptan a diferentes tamaños de pantalla. Ya sea a través de WI-FI o de su red de datos, tendrá acceso a sus informes cuando lo desee.",
    },
    our_apps: {
      title: "CON NUESTRA APLICACIÓN PUEDES…            ",
      section_text:
        "Siempre estamos actualizando y agregando funciones a nuestra aplicación, tanto para Android como para iOS.",
      functionalities_list: {
        dashboards_text: "Ver sus dashboards",
        filter_text: "Filtrar, desglosar y acercar",
        notifications_text: "Recibir notificaciones",
        export_pdf_text: "Exportar en PDF",
        send_email_text: "Enviar por email",
      },
    },
    suitable_apps: {
      title: "APLICACIÓN ADECUADA PARA TABLET",
      section_text: "En versión para tabletas. Disponible en Android y iOS.",
    },
    potency: {
      title: "PEQUEÑO EN TAMAÑO, GIGANTE EN POTENCIA",
      potency_smartphone: {
        section_text_1:
          "Ideal para lograr KPI de rendimiento, los teléfonos inteligentes son excelentes en este formato.",
        section_text_2:
          "Acceda fácilmente a hojas de cálculo y gráficos con una excelente apariencia. Asegure sus datos al alcance de su mano.",
      },
      potency_tablet: {
        section_text_1: "Obtenga más vistas desde la pantalla de su tableta.",
        section_text_2:
          "Las tabletas más recientes garantizan una mayor interacción, con sus lápices táctiles, en nuestros dashboards.",
        section_text_3:
          "Perfecto para demostraciones, ventas o reuniones. Impresione con nuestros dashboards.",
      },
    },
  },

  tickets: {
    title: "TICKETS DE ASISTENCIA Y APOYO EN LÍNEA",
    section_text:
      "Obtenga acceso a todas las reglas y procesos de su empresa con nuestros recursos en línea.",
    resources: {
      title: "ACCEDE A TODOS NUESTROS RECURSOS            ",
      section_text_1:
        "Nuestro equipo de soporte está aquí para brindarle toda la información que necesita sobre Hyaia.",
      section_text_2:
        "¿Quieres saber más sobre Hyaia? Comuníquese con nosotros a través de nuestros canales de atención.",
    },

    online_support: {
      title: "ASISTENCIA EN LÍNEA            ",
      section_text:
        "Hacemos todo, desde conectar datos, preparar y transformar información hasta visualizaciones avanzadas.",
    },

    content_faq: {
      title: "PREGUNTAS FRECUENTES CON CONTENIDO            ",
      section_text_1:
        "Resolvemos tus dudas más actuales en las FAQ (Preguntas Frecuentes) online. Accede rápidamente a las respuestas a tus preguntas específicas, como:",
      section_text_2: "“¿Cómo se realiza la conexión a mi base de datos?”  ",
    },

    support_tickets: {
      title: "PROGRAMA DE ENTRADAS DE APOYO CONECTADO",
      section_text:
        "Obtenga un ticket de soporte para que nuestros expertos lo ayuden con sus soluciones. Nuestro equipo es recomendado por nuestros clientes por su calidad y soporte.",
    },
  },

  chat: {
    title: "HABLA DIRECTAMENTE CON NUESTROS EXPERTOS        ",
    section_text:
      "Obtenga asistencia de nuestro equipo de expertos en soluciones, directamente desde su cuenta con el chat de ayuda, a través de nuestro sitio web.",
    chat_expert: {
      title: "¿NECESITA AYUDA? CHATEA AHORA CON UNO DE NUESTROS EXPERTOS",
      section_text_1:
        "¿Tiene problemas para relajarse? ¿Está tratando de recordar una regla o un proceso para crear sus dashboards?",
      section_text_2:
        "En Hyaia te ofrecemos la ayuda que necesitas para visualizar al máximo tu información.",
    },

    need_help: {
      title: "EN EL LUGAR QUE LO NECESITAS            ",
      section_text_1:
        "Con Hyaia será posible: aprender una nueva solución, crear reglas y procesos y convertirse en un experto en datos confiables.",
      section_text_2:
        "A través de nuestro chat integrado, puede hablar de inmediato con nuestro equipo de analistas comerciales y expertos en Hyaia. Para ayudar con:",
      section_text_3: "Cómo empezar a utilizar nuestra plataforma.            ",
      section_text_4: "Visualización y conexión de datos.            ",
      section_text_5: "Creación de reglas y procesos de negocio.            ",
      section_text_6:
        "Programación de instalaciones y automatismos.            ",
      section_text_7: "Despeja dudas al instante.            ",
      section_text_8: "Es mucho más.            ",
      section_text_9:
        "Se puede acceder a nuestro chat integrado con algunos niveles de licencia y con una opción para acceder a otros.",
    },

    governance: {
      title: "DISFRUTA CADA TOMO DE GOBIERNO",
      section_text_1:
        "Nuestro equipo puede mostrarle cómo aprovechar al máximo nuestra tecnología en sus datos.",
      section_text_2: "Te ayudamos a potenciar:            ",
      section_text_3: "El poder de la automatización.            ",
      section_text_4: "Gestión de reglas y procesos.            ",
      section_text_5: "Cuadros de mando y KPI.            ",
      section_text_6:
        "Y otras características de BRA de nuestra increíble plataforma.            ",
    },

    customer_testimonials: {
      title:
        "SEJA ACOMPANHADO, EM TODOS OS SEUS PROCESSOS E REGRAS, PELA NOSSA EQUIPE DE SUPORTE",
      customer_testimonial_1: {
        section_text_1: "Não imaginava que seria tão fantástico assim.",
        section_text_2: "",
        section_text_3: "",
      },
      customer_testimonial_2: {
        section_text_1:
          "Antes, eu tinha que fazer várias conciliações, usar vários sistemas, pagar caro em auditorias e esperar muito tempo para ver os resultados. Quando coloquei a Hyaia, tudo o que acontecia na empresa chegava em tempo real pra mim. Parecia que estava em um outro mundo, por causa de tanta tecnologia e profissionalismo da Hyaia.",
        section_text_2: "Mike Owens",
        section_text_3: "CEO",
      },
      customer_testimonial_3: {
        section_text_1: "Aumentamos assustadoramente nossas margens de lucro.",
        section_text_2: "",
        section_text_3: "",
      },
      customer_testimonial_4: {
        section_text_1:
          "Depois que implantamos a Hyaia para confrontar nossas regras e processos de negócio. Começamos a detectar todas as fontes de perda financeira da companhia, conseguindo estancá-las de maneira cirúrgica e rápida. Recebemos até antecipações de problemas, para tomar atitudes de prevenção. Nosso lucro aumentou, a empresa está crescendo mais e nossos acionistas estão felizes.",
        section_text_2: "Louise Monreau",
        section_text_3: "CFO",
      },
    },
  },

  rapid_dashboard: {
    title: "DISEÑADOR DE DASHBOARDS ÁGIL Y FÁCIL        ",
    section_text:
      "Convierta datos sin procesar en ideas, rápida y fácilmente, con nuestro panel de control para clientes. ¡No requiere instalación!",
    drag_and_drop: {
      title: "DISEÑADOR DE DASHBOARDS DE ARRASTRAR Y SOLTAR            ",
      section_text_1:
        "Sin las herramientas adecuadas para unir conexiones, significados y conocimientos, los datos son solo números. Hyaia hace posible convertir información en dashboards con nuestro potente e intuitivo diseñador.",
      section_text_2:
        "Comience a ver el rendimiento, las pendientes, las anticipaciones y los resultados a través de gráficos, KPI, hojas de cálculo y más. Con nuestro aspecto de dashboard de arrastrar y soltar, puede crear dashboards en muy poco tiempo.            ",
      section_text_3:
        "APP con 'arrastrar y soltar' para colocar el Dashboard. ",
    },
    data_visualization: {
      title: "MUCHAS FORMAS DE VER LOS DATOS",
      section_text_1:
        "Acceda a una amplia biblioteca de herramientas de diseño para ayudarlo a dar vida a sus datos.",
      section_text_2:
        "Desarrolle sus cuadros de mando e impresione a su equipo y a sus clientes a través de presentaciones directas, impactantes y agradables.",
    },

    impressive_dashboards: {
      title: "CUADROS EXTRAORDINARIOS",
      section_text_1:
        "Los informes y cuadros de mando deben ser atractivos, directos y objetivos. Valorando las áreas que necesitan ser analizadas constantemente.",
      section_text_2:
        "Los dashboards con imágenes modernas, claras y objetivas facilitan la lectura e impresionan a sus usuarios.",
      section_text_3:
        "Identifique patrones y valores atípicos con dashboards bien diseñados y acceda instantáneamente a los datos que necesita.",
    },

    action: {
      title: "VÉALO EN ACCIÓN",
      section_text_1:
        "Piense en no tener que 'copiar y pegar' diferentes tipos de datos y exportar documentos de texto para obtener solo una hoja de cálculo o un gráfico.",
      section_text_2:
        "¡No pierdas más tiempo! Comienza tu viaje a través de Hyaia y accede al futuro.            ",
    },

    widgets: {
      title: "WIDGETS DE VISUALIZACIÓN DE DATOS",
      section_text_1:
        "Varios tipos de gráficos. Combinar una barra de columnas con un gráfico de líneas. Una hoja de cálculo, simple o compleja, para una presentación clara.",
      section_text_2:
        "Filtre datos o ejecute una regla comercial con un widget de entrada. Inserta títulos, imágenes y videos y haz que se vea genial.",
      section_text_3:
        "Resalte un indicador, un número de indicador clave, un gráfico con viñetas o muestre información en Google Maps.",
      section_text_4:
        "Descubra su habilidad para diseñar Dashboard y vaya más allá con nuestros editores.",
    },

    auto_update: {
      title: "ACTUALIZACIÓN AUTOMÁTICA",
      section_text_1:
        "Cada actualización, eliminación o adición de datos en su tablero se actualizará de inmediato.",
      section_text_2:
        "Hyaia supervisa toda la información y actualiza todos los dashboards conectados.",
    },

    fast_interaction: {
      title: "INTERACTUAR INMEDIATAMENTE",
      section_text:
        "Con Hyaia, su información es accesible con un solo clic. Acérquese, filtre o profundice y vea lo que necesita.",
    },

    custom_dashboards: {
      title: "CUADROS PERSONALIZADOS",
      section_text:
        "Pon tu cara en el look de cualquier dashboard. Mantener la identidad de su marca, empresa o cliente. Y desarrolle fuentes, colores, fondos y más.",
    },
  },

  scheduling: {
    title: "AUTOMATIZACIÓN, PROGRAMACIÓN Y ALERTAS",
    section_text:
      "Sus datos se actualizan y publican automáticamente en dashboards e workflows, en función de las ocurrencias, todo como resultado de nuestra tecnología Business Revenue Assurance.",
    know_everything: {
      title: "CONOCE TODO LO QUE PASA EN TU NEGOCIO",
      section_text:
        "Deje sus datos actualizados y reciba alertas cuando nuestro módulo de workflow infrinja cualquier regla comercial, política operativa, detección de fraude u otro incumplimiento. Resuelve tus molestias rápidamente y mejora los procesos de tu empresa.",
    },

    kpis: {
      realtime_kpis: {
        title: "KPI EN TIEMPO REAL",
        section_text:
          "Confronte sus KPI con nuestro módulo INDICADOR y vea, en tiempo real o casi en tiempo real, nuestros KPI en sus datos y compárelos con los indicadores de su negocio.",
      },

      alerts: {
        title: "ALERTAS EN TIEMPO REAL POR INCUMPLIMIENTO",
        section_text:
          "Supervise el 100% de sus procesos y reglas comerciales, y reciba alertas en tiempo real sobre fraude, incumplimiento de reglas y procesos, pérdida financiera e incumplimiento.",
      },

      data: {
        title: "DATOS Y REGLAS DE TUS CLIENTES MONITORIZADOS AL INSTANTE",
        section_text_1:
          "Asegure la interoperabilidad y comunicación de los procesos y reglas de sus clientes. Hyaia es capaz de monitorear, auditar y supervisar todas las políticas contractuales de sus clientes, generar alertas y notificaciones cuando existe riesgo y amenaza. De esta forma, previene incumplimientos de contrato, multas, riesgo para la imagen de su empresa y pérdida de clientes.",
        section_text_2: "Amplíe su productividad.",
      },

      manage: {
        title: "SIGA EL DESARROLLO DEL RENDIMIENTO DE SU NEGOCIO",
        section_text:
          "Sea más ágil, monitoreando sus procesos, sectores y equipos. Siga el flujo de su empresa y tome decisiones estratégicas y asertivas, con base en la información generada por Hyaia.",
      },

      data_automatization: {
        title: "AUTOMATIZACIÓN DE DATOS",
        section_text:
          "Establecer y olvidar. La automatización de datos de Hyaia garantiza que sus datos e información estén constantemente actualizados en todas sus fuentes. Semanalmente, todos los días y cada minuto.",
      },

      data_update: {
        title: "ACTUALIZACIÓN DE DATOS                ",
        section_text:
          "Sus informes y cuadros de mando se actualizan con cada nuevo dato imputado. Todo analizado, auditado y conciliado con sus procesos, normas y políticas corporativas.",
      },
    },
  },

  connectors: {
    title: "CONECTORES DE DATOS        ",
    section_text:
      "Hyaia se conecta con todo tipo de bases de datos, sistemas, archivos y bases de información, independientemente del formato, potenciando como una tecnología inclusiva.",
    reconcile: {
      title: "¿NECESITAS CONCILIAR Y CONFRONTAR TUS DATOS?            ",
      section_text:
        "Dondequiera que estén sus datos (hojas de cálculo, txt, aplicación, base de datos, nube o ubicación física), Hyaia puede conectarse con todos ellos simultáneamente. Y aplique las reglas de negocio, las políticas estratégicas y operativas de su organización. Detectando en su caso: irregularidad, exposición al riesgo, fraude y pérdidas económicas.",
    },
    business_apps: {
      title: "APLICACIONES DE NEGOCIOS            ",
      section_text_1:
        "¿Sus aplicaciones de gestión tienen datos valiosos? ¿Puedes leerlos, reconciliarnos y confrontarlos en tiempo real?",
      section_text_2:
        "Las conexiones seguras de Hyaia pueden hacer eso, así como generar indicadores y workflow, sobre cualquier eventualidad que tenga su base de datos y que afecte las ganancias de su organización.",
      section_text_3:
        "No pierda tiempo y dinero, comience a rastrear su empresa en la palma de su mano.            ",
    },
    social_media_connectors: {
      title: "CONECTORES DE MEDIOS SOCIALES            ",
      section_text:
        "Evalúe la imagen de su empresa y las clasificaciones externas de Hyaia. Totalmente fácil de usar e intuitivo, nuestro asistente de conexión de datos lo ayudará a conectar sus cuentas de redes sociales y analizarlas en minutos.",
    },
    cloud_connectors: {
      title: "BASE DE DATOS EN LA NUBE Y LOCAL            ",
      section_text:
        "Si tienes una base de datos, ya sea en la nube con un terabyte en Google Big Query o Amazon RedShift, en una base de datos relacional Oracle o MySQL local, y quieres conciliarlas y confrontarlas en tiempo real, viendo todo en dashboards, tenemos la respuesta correcta a su necesidad.",
    },
    spreedsheet: {
      title: "HOJAS DE CÁLCULO Y ARCHIVOS DE TEXTO            ",
      section_text_1:
        "Las empresas siempre tendrán una parte importante de sus datos en hojas de cálculo y archivos de texto, debido a la sencillez de la base de datos más básica.",
      section_text_2:
        "En Hyaia, nuestros conectores permiten leer, conciliar y comparar, de forma fácil y rápida, con diversos servicios de almacenamiento de datos. Incluso sus correos electrónicos se pueden agregar y convertir en dashboards. ",
    },
    web_services: {
      title: "SERVICIOS WEB Y API            ",
      section_text:
        "Hyaia es una herramienta increíble, sea cual sea su integración. A través de nuestro Web Service Connector, podemos conectarnos a cualquier API, REST o SOAP, utilizando diferentes tipos de autenticación, desde Básica hasta OAuth2 o AWS Signature. Independientemente de si las API, que requieren parámetros o macros, se pueden usar para obtener toda la potencia y la automatización. Vea soluciones como: XML, JSON o Delimited.",
    },
    thousands: {
      title: "CONÉCTESE A MILES DE APLICACIONES A TRAVÉS DE HYAIA",
      section_text:
        "En Hyaia puede reconciliar e recopilar workflow de datos de numerosas aplicaciones simultáneamente.",
    },
    safe_information: {
      title: "SU INFORMACIÓN ESTÁ SEGURA            ",
      section_text:
        "No te preocupes, tus datos no importan. Nuestra solución lee todos los datos de su fuente original y genera todos los dashboards, workflow e informes necesarios, en tiempo real, a través de conexiones  VPN. Solo usted y las personas autorizadas tienen acceso a la información leída por Hyaia.",
    },

    customer_testimonials: {
      title: "GRANDES CLIENTES PELO MUNDO",
      section_text:
        "Veja o que nossos clientes pensam sobre a atuação da Hyaia em seus negócios?",
    },

    lets_go: {
      section_text: `No pierdas tiempo y comienza a utilizar la mejor tecnología del mundo en BRA.`,
    },
  },

  health: {
    title: "TU HOSPITAL FINANCIERAMENTE SALUDABLE        ",
    section_text:
      "Rastree, de punta a punta, todos los trámites, seguros de salud, farmacia, recurrencia, contratos y aumente las ganancias de su organización para un crecimiento exponencial.",
    perform_better: {
      title: "GESTIONA MEJOR TU ESPECIALIDAD CON DATOS EN TIEMPO REAL",
      section_text_1:
        "Encuentre formas de reducir costos, aumentar la calidad del servicio y optimizar la atención al paciente.            ",
      section_text_2:
        "Con informes actualizados, tiene acceso a información precisa y correcta sobre cualquier aspecto de su servicio de atención médica.",
    },
    medical_bill_list: {
      medical_bill: {
        title: "FACTURAS MÉDICAS                ",
        section_text_1:
          "Conciliar y auditar en tiempo real historias clínicas, contratos, cumplimentación de formularios y convenios.",
        section_text_2:
          "Recortar costes, mantener las finanzas organizadas, recibir correctamente las cantidades repercutidas por el seguro médico o las consultas privadas. Reduciendo así los brillos médicos.",
      },

      management_procedures: {
        title: "PROCEDIMIENTOS ADMINISTRADOS                ",
        section_text:
          "Con alta potencia computacional y lenguaje propio de 4ª generación, Hyaia monitorea y garantiza el conjunto de acciones asistenciales y administrativas necesarias, suficientes para la plena realización de los procedimientos quirúrgicos. Contemplando los recursos humanos, instalaciones físicas, equipos, instrumentos y materiales de entrada inherentes al proceso de atención.",
      },

      pharmacy: {
        title: "FARMACIA",
        section_text:
          "Garantizar el uso seguro y racional de los medicamentos prescritos, atendiendo las demandas de los pacientes hospitalizados. Mayor control y sin desperdicios, todo en su justa medida.",
      },

      profit: {
        title: "FACTURACIÓN",
        section_text_1:
          "Cuentas revisadas, auditadas y comprobadas antes de ser enviadas a los operadores de salud.",
        section_text_2:
          "Mayor agilidad en el envío de facturas, y rapidez en la recepción de pagos.",
      },

      glosa: {
        title: "BRILLO",
        section_text:
          "Acaba con los problemas de comunicación y ten informes precisos en tiempo real. Minimice el brillo en su organización de atención médica tanto como sea posible.                ",
      },
      contracts: {
        title: "CONTRATOS",
        section_text_1:
          "Asegurar las reglas de cada contrato y tener una gestión hospitalaria rentable.                ",
        section_text_2:
          "Haga cumplir automáticamente las reglas de contrato de su organización de atención médica y controle todos los parámetros de cumplimiento establecidos en tiempo real.",
      },
    },
  },

  industry: {
    title: "TU EMPRESA MAS PRODUCTIVA CON MENOS GASTOS",
    section_text_1:
      "Use Hyaia para administrar y monitorear todos sus departamentos, cadenas productivas, operativas y financieras de su negocio.",
    section_text_2:
      "Vea, en tiempo real, todo lo que se pierde y recupera en sus acciones diarias en la empresa.",
    economy: {
      title:
        "CADA CENTAVO AHORRADO EN SU LÍNEA DE PRODUCCIÓN PUEDE CONVERTIRSE EN MILLONES",
      section_text_1:
        "Impulse la puesta a punto de su cadena de procesos y mejore sus reglas de negocio en sus líneas de producción, haciéndola más rápida y económica.",
      section_text_2:
        "A través de la tecnología Deep Learning, Hyaia puede aumentar sus ganancias y brindar resultados increíbles a su empresa.",
    },

    artificial_inteligence: {
      title: "INTELIGENCIA ARTIFICIAL EN TU NEGOCIO            ",
      section_text:
        "Con nuestras tecnologías, desde Business Intelligence, Business Revenue Assurance, Big Data, Machine Learning, Deep Learning e Internet Of Things, tenga una mejor visión y mayor control de procesos, reglas, departamentos, cadena de suministro, logística inversa, WMS, MRP1, MRP2 , inventario, EMII, CMN entre otros factores importantes de su organización.",
    },

    consulting: {
      title: "AUDITORÍA Y CONSULTORÍA            ",
      section_text_1:
        "Cuente con nuestros equipos de consultores y tecnología para ayudar en la estructuración de procesos, reglas y políticas, optimizando el examen de su negocio para obtener informes precisos y en tiempo real.",
      section_text_2:
        "Promueva Revenue Assurance en las cadenas operativas y financieras de su empresa.",
      section_text_3:
        "Audita tus sistemas ERP, CRM, WMS, Risk & Compliance y fiscales.            ",
    },

    antifraud: {
      title: "ANTI FRAUDE            ",
      section_text:
        "Protege tu negocio y detectar cualquier fraude en tiempo real. Cada centavo puede marcar la diferencia al final.",
    },

    kpis: {
      title: "KPI y OKR",
      section_text_1:
        "Confronta los KPI y OKR de tu empresa con datos precisos y conciliados.            ",
      section_text_2:
        "Hyaia puede generar indicadores basados ​​en los datos auditados y compararlos con los indicadores de sus sistemas, mostrando discrepancias para mejorar el desempeño.",
    },

    workflow: {
      title: "WORKFLOW DE PROBLEMAS EN TIEMPO REAL            ",
      section_text_1:
        "Recibe notificaciones de inmediato de cada irregularidad que consuma tus ganancias.",
      section_text_2:
        "Con Hyaia recibes alertas, en tiempo real, con un grado de escalabilidad hasta que se soluciona el problema.",
      section_text_3: "Cuanto más rápida sea la acción, menor será la pérdida.",
    },
  },

  retail: {
    title: "BENEFICIOS GARANTIZADOS EN B2C",
    section_text:
      "Tenga una visión completa y siga, en tiempo real, todo lo que sucede en su negocio minorista",
    numerous_processes: {
      title:
        "MUCHOS PROCESOS EN RETAIL PARECEN ALGO IMPOSIBLE DE CONTROLAR, CON HYAIA ESTO NO ES UN PROBLEMA.",
      section_text_1:
        "Sigue, en tiempo real, el rendimiento de tu tienda, comercio electrónico y omnicanal.            ",
      section_text_2:
        "Reconcilie su base de datos y resuelva problemas en tiempo récord con nuestros dashboards interactivos.",
    },
    product_performance_list: {
      product_performance: {
        title: "RENDIMIENTO DEL PRODUCTO",
        section_text:
          "Vea el rendimiento de sus productos, en todos los canales de venta, en tiempo real. Las actualizaciones automáticas asegurarán que siempre esté informado.",
      },
      inventary_control: {
        title: "CONTROL DE INVENTARIO                ",
        section_text:
          "Mantenga el inventario bajo, relacione con modelos predictivos, realice un seguimiento de los artículos en el estante más fácilmente y mantenga todos los precios actualizados con un tablero, en tiempo real.",
      },
      profit_up: {
        title: "AUMENTO DE BENEFICIOS",
        section_text:
          "Ahorre mucho al tener una visión general y una vista detallada de todo su negocio.                ",
      },
      orders: {
        title: "PEDIDOS Y FACTURACIÓN",
        section_text: "Supervise todos los pedidos y facturas a través de dashboards inteligentes, informes en tiempo real, dentro de las normas y políticas corporativas de su empresa.",
      },
      analysis: {
        title: "ANÁLISIS DE INDICADORES DE COMERCIO ELECTRÓNICO",
        section_text:
          "KPI precisos de su negocio en línea en tiempo real. Tomar decisiones y crear estrategias para alcanzar metas con indicadores esenciales y confiables.",
      },
      customer: {
        title: "CONQUISTANDO CLIENTES                ",
        section_text:
          "Descubra rápidamente qué ventas fueron efectivas. Realice un seguimiento de sus tasas de conversión, el tráfico de nuevos clientes, centralice los ingresos y optimice sus estrategias de marketing.",
      },
    },
  },

  telecom: {
    title: "EL NUEVO Y MEJOR CONCEPTO EN BRA PARA TELECOMUNICACIONES",
    section_text_1:
      "Con Hyaia, la interoperabilidad de las telecomunicaciones es posible.",
    section_text_2:
      "Mejore sus procesos y la calidad de sus datos con nuestra tecnología. Optimización de sus ganancias, ingresos, flujo de efectivo sin influir en la demanda del servicio.",
    invoice: {
      title: "LAS FACTURAS NO CONCILIABLES PUEDEN SER COSTOSAS",
      section_text_1:
        "A través de Hyaia, las facturas y planes de sus clientes serán correctos y sin ambigüedades.",
      section_text_2:
        "Cada cliente tendrá un plan y una regla. Tenga lo mejor en BRA para monitorear y administrar individualmente.",
      section_text_3:
        "Obtenga informes en tiempo real en los dashboards y muéstreselos a su equipo para mejorar la gestión de su empresa.",
    },
    cdr_list: {
      cdr: {
        title: "CDR",
        section_text_1:
          "Audita toda la información del registro de llamadas de tus clientes, aplicando las reglas de cada plan en cada llamada.",
        section_text_2:
          "El control total de las llamadas de sus clientes puede ser una gran fuente de ahorro, ganancias y protección contra la facturación indebida de los clientes.",
      },

      routing: {
        title: "ENRUTAMIENTO INCORRECTO                ",
        section_text_1:
          "La entrega de datos para cada plan debe ser efectiva y monitoreada, asegurando la rentabilidad de la empresa y la satisfacción del cliente.                ",
        section_text_2:
          "Hyaia puede verificar y notificar fallas de enrutamiento. Comunicar al operador, en tiempo real, situaciones que crean problemas entre el cliente y la empresa de Telecom, socavando sus ganancias, riesgo e imagen.",
      },

      business_rules: {
        title: "REGLAS DE NEGOCIO INEXACTAS                ",
        section_text_1:
          "Vea qué reglas no son válidas, inútiles o están desactualizadas en su sistema con Hyaia.",
        section_text_2:
          "Promueva una afinación de reglas y procesos, para que su flujo de atención sea cada vez más asertivo y más rentable.",
      },

      subscriptions: {
        title: "APROVISIONAMIENTO DE SUSCRIPTORES                ",
        section_text_1:
          "Identifique el grado de funcionalidad y claridad de aprovisionamiento para los abonados de su operador.",
        section_text_2:
          "Seguir a través de los cuadros de mando interactivos el comportamiento de los sistemas en relación con la implantación o adecuación de servicios a sus usuarios.",
        section_text_3:
          "Detecta errores de configuración o instalación sistémica, y actúa con anticipación, asegurando el nivel de satisfacción de tus suscriptores.",
      },

      precision_errors: {
        title: "FALLAS DE PRECISIÓN DE CLASIFICACIÓN Y FACTURACIÓN",
        section_text_1:
          "Consultar, en tiempo real, las reglas de negocio sobre fijación de precios, facturación y negociación según el tamaño de cada cliente.",
        section_text_2:
          "Ponga fin a las discrepancias, la exposición al riesgo, las pérdidas financieras y el fraude con la ayuda de nuestros módulos.",
      },
    },
  },

  corp_chain: {
    title:
      "NO SEA SUJETO A SUS PREOCUPACIONES, EXAMINA LAS CADENAS CORPORATIVAS DE TU NEGOCIO",
    analyze_corp_chain: {
      title: "",
      section_text_1:
        "Toda gran organización tiene sus procedimientos, preceptos y políticas corporativas, ordenados en cadenas de procesos.",
      section_text_2:
        "Administrar, monitorear, evaluar y auditar cada uno de ellos parece un trabajo enorme.",
      section_text_3:
        " Con Hyaia se puede consultar el ciclo de las reglas de su negocio en tiempo real. Recibir alertas instantáneas de cualquier incumplimiento de regla o proceso.            ",
    },

    realtime_process: {
      title: "CADA PROCESO Y REGLA VISTO EN TIEMPO REAL            ",
      section_text:
        "Monitorea y rastrea todo lo que sucede en tus cadenas corporativas. Ver información en dashboards interactivos con cada actualización de datos.",
    },

    fin_chain: {
      title: "CADENA FINANCIERA            ",
      section_text_1:
        "La gestión financiera de su organización es monitoreada y auditada de principio a fin. Reglas para cualquier modelo de negocio, encaminadas a reducir costes y aumentar los beneficios.",
      section_text_2:
        "No pague notas duplicadas, impuestos dobles, guías con cálculos incorrectos y, entre otras cosas, que puedan ser pagadas indebidamente.",
      section_text_3:
        "Ponle tus reglas a Hyaia y déjala monitorear. Y avísanos si hay algún posible error en tus finanzas.",
    },

    op_chain: {
      title: "CADENA OPERATIVA            ",
      section_text_1:
        "Imagine monitorear, medir el nivel de rendimiento y resultados, optimizar las reglas para todas sus operaciones comerciales.",
      section_text_2:
        "Hyaia es la mejor solución tecnológica, capaz de realizar esta tarea y generar informes, en tiempo real, de todo lo que sucede en su empresa.",
    },

    corp_policies: {
      title: "POLÍTICAS CORPORATIVAS            ",
      section_text_1:
        "Las políticas que rigen su negocio son seguidas, verificadas y monitoreadas por los mejores en Business Revenue Assurance con A.I.",
      section_text_2:
        "Elimine riesgos y deje su empresa siempre de acuerdo con la ley, y con las reglas de los negocios con sus clientes.",
    },
  },

  database: {
    title: "HYAIA LLEGA DONDE LO NECESITAS        ",
    section_text_1:
      "Si sus datos están en la cloud o on-premise, no hay problema.        ",
    section_text_2:
      "Nuestra tecnología, no intrusiva, llega a sus bases y realiza los procesos.",
    data_protection: {
      title: "LA PROTECCIÓN DE TUS DATOS ES NUESTRA PRIORIDAD",
      section_text_1:
        "Una herramienta innovadora en lectura de datos y conversión de informes.            ",
      section_text_2:
        "Obedeciendo a la LGPD sus datos estarán protegidos y seguros, a través de nuestras conexiones de lectura de información.",
    },

    in_cloud_db: {
      title: "IN CLOUD      ",
      section_text:
        "Si tu información está en la nube, a través de conexiones VPN, Hyaia realiza análisis de datos en su propia base. Se convierte en dashboards e informes en tiempo real, lo que garantiza su seguridad.",
    },

    on_premise: {
      title: "ON PREMISE      ",
      section_text_1:
        "Si su base de datos es física, nuestro equipo de especialistas acudirá a ellas. Siguiendo todos los procedimientos necesarios, para que la lectura de los elementos se haga de forma segura y asertiva.",
      section_text_2:
        "Nuestra tecnología no importa ningún material. Simplemente los lee y los convierte externamente en informes y dashboards, para una mejor toma de decisiones.",
    },
  },

  education: {
    title: "CON HYAIA TU SISTEMA EDUCATIVO ES UN GRADO 10        ",
    section_text_1:
      "Las instituciones educativas cuentan con numerosos procesos con numerosas reglas para asegurar la calidad, gestión y control del flujo de trabajo y la demanda de los estudiantes. Sin mencionar los sistemas, hojas de cálculo, historial y otros datos, que son de suma importancia para la entidad a través de organismos reguladores como el MEC.",
    section_text_2:
      "Asegurar la fluidez de la cadencia educativa y financiera de su institución educativa es nuestra especialidad.        ",
    e2e_control: {
      title: "CONTROL DE EXTREMO A EXTREMO",
      section_text:
        "Nuestra tecnología no es intrusiva, Hyaia se comunica con cualquier base de datos y en cualquier formato. Realizando la lectura y aplicación de procesos, normas y políticas corporativas de su organización, generando reportes en tiempo real a través de modernos e interactivos dashboards.",
    },

    financial_list: {
      financial: {
        title: "FINANCIERO",
        section_text_1:
          "Supervise y audite sus cuentas en tiempo real.                ",
        section_text_2:
          "Sepa dónde, cuándo y cómo está cada centavo en su institución educativa.                ",
        section_text_3:
          "Reduzca costos, encuentre estafas y observe cómo se disparan sus ganancias.                ",
      },
      register: {
        title: "INSCRIPCIÓN                ",
        section_text_1:
          "Asegura la gestión de las matrículas de tus alumnos, seguimiento de pagos, cláusulas contractuales, entradas y salidas de alumnos a través de indicadores fiables en tiempo real.",
        section_text_2:
          "Toma decisiones rápidas y asertivas para la expansión de tu institución educativa.                ",
      },
      student_allocation: {
        title: "ARRENDAMIENTO DE CLASES                ",
        section_text_1:
          "El seguimiento y la gestión de las clases no es tarea fácil, infinidad de factores pueden potenciar o deconstruir las clases desde su motivación educativa.",
        section_text_2:
          "Hyaia se asegura de que sus reglas, para la formación, ubicación, seguimiento y desarrollo de las clases, sean monitoreadas e informadas de la mejor manera posible.",
      },
      history: {
        title: "HISTORIAL ESCOLAR                ",
        section_text_1:
          "Notas, ausencias, promedios, aprobaciones, recuperaciones, TCC, monografías multiplicadas; teniendo en cuenta el número de alumnos, es una cadena educativa inmensa de controlar y monitorear, incluso pareciendo imposible en tiempo real.",
        section_text_2:
          "Pero con Hyaia esto se puede resolver fácilmente, las reglas de expediente académico de su escuela junto con sus procesos se pueden monitorear y reportar, en tiempo real, asegurando la efectividad de su trabajo académico y la satisfacción de sus estudiantes.",
      },
    },
  },

  ecommerce: {
    title: "TU E-COMMERCE ES SIEMPRE EFICIENTE Y GENERADORA DE BENEFICIOS",
    section_text_1:
      "Las ventas en línea son el futuro, más del 56% de las ventas minoristas físicas están influenciadas por algún tipo de canal digital en estos días. ",
    section_text_2:
      "Sin embargo, asegurar la interoperabilidad entre la cadena física y la digital en el comercio electrónico no es tan sencillo.",
    section_text_3:
      "Hyaia es la mejor solución para realizar un seguimiento de sus procesos y reglas de comercio electrónico. ",
    fast_efficient: {
      title: "DIGITAL, RÁPIDO Y EFICIENTE            ",
      section_text:
        "Vea en tiempo real todos los procesos, reglas y políticas corporativas de su comercio electrónico, inspeccionado y auditado en toda la base de datos de sus tecnologías.",
    },

    card_fraud_list: {
      fraud: {
        title: "FRAUDE DE TARJETAS                ",
        section_text:
          "Detecte compras fraudulentas y sea notificado de inmediato, garantice la credibilidad de sus ventas. Evita pérdidas de mercancía y cancelaciones de ventas.                ",
      },
      logistics: {
        title: "LOGISTICA",
        section_text_1:
          "Con los módulos de Hyaia como Big Data, Machine Learning y Deep Learning, puede reducir costos y aumentar sus ganancias.",
        section_text_2:
          "Sepa dónde, cómo y en qué estado se encuentran sus productos, desde el regimiento hasta la entrega al cliente final.",
      },

      reverse_logistics: {
        title: "LOGÍSTICA INVERSA                ",
        section_text_1:
          "Recibir un producto devuelto implica una serie de trámites, normas y procesos que cuestan dinero. Y sale más caro cuando no se tiene el control de punta a punta de la logística inversa y la garantía de seguimiento de sus políticas corporativas.",
        section_text_2:
          "Realice un seguimiento, en tiempo real, de dónde y cómo se encuentran sus productos en el proceso de devolución, reduzca costos, optimice procesos y aumente sus márgenes de beneficio.",
      },

      churn: {
        title: "CHURN",
        section_text_1:
          "¿Cuánto vale un cliente que renuncia a tu marca, producto o servicio? Aún más caro es si difama tu e-commerce.",
        section_text_2:
          "Entender y monitorear, a través de indicadores, por qué y cuántos de tus clientes no te compran es algo que Hyaia brinda a tu negocio, para que puedas tomar decisiones y convertir las pérdidas en lealtad.",
        section_text_3:
          "Incrementa tu portafolio y ten el mejor boca a boca para tu empresa, con la información generada por Hyaia.",
      },
    },
  },

  public_sector: {
    title: "AUMENTO DE LA RECAUDACIÓN Y DESEMPEÑO DE LA GESTIÓN PÚBLICA",
    section_text:
      "Hyaia puede optimizar las fuentes de ingresos del municipio y monitorear el desarrollo del desempeño de los departamentos y sectores públicos.",
    mgnt: {
      title:
        "LA GESTIÓN PÚBLICA NO ES TAN SIMPLE, PERO A TRAVÉS DE HYAIA TODO ES POSIBLE.",
      section_text_1:
        "El sector público tiene varios sectores, con infinitos procesos, diferentes reglas y políticas de gestión. La cantidad de datos y sistemas para esta demanda es alta, y rastrearlos a todos, multiplicados por la población, es aún más difícil.",
      section_text_2:
        "Hyaia es el mejor sistema de seguimiento y gestión de procesos en el sector público. Promoviendo más resultados que se conviertan en beneficios para la población.",
    },

    warranty_list: {
      warranty: {
        title: "GARANTÍA Y RECUPERACIÓN DE IMPUESTOS",
        section_text_1:
          "Con capacidad para procesar más de 20 mil millones de cruces de datos/día, descubre impuestos mal pagados con correcciones, multas e intereses actualizados.",
        section_text_2:
          "Tener, en tiempo real, fuentes de ingresos municipales actualizadas para acciones que beneficiarán a la población.",
      },
      service_high: {
        title:
          "DESEMPEÑO DE DEPARTAMENTOS, SERVICIOS Y SECTORES                ",
        section_text:
          "Siga, compare y vea la evolución de los sectores y departamentos municipales o estatales en tiempo real. Comparación de indicadores y optimización de la velocidad de los procesos y agilidad de los servicios públicos.",
      },
      digital_reports: {
        title: "INFORMES DIGITALES                ",
        section_text_1:
          "Reduzca costos compartiendo información con su equipo, sus electores, sus residentes y contribuyentes.",
        section_text_2:
          "A través de Hyaia presentamos cuadros de mando instantáneos en formato digital.                ",
      },
      performance_dashboard: {
        title: "DASHBOARD DE RENDIMIENTO                ",
        section_text:
          "Con dashboards interactivos, obtenga una descripción general del seguimiento y la gestión del tiempo del equipo. Filtre por proyecto de proveedor, equipo o usuario del equipo.",
      },
      project_status: {
        title: "SEGUIMIENTO DEL ESTADO DEL PROYECTO                ",
        section_text:
          "Los gerentes de proyecto pueden usar este tablero para rastrear todos los KPI, hasta la finalización del proyecto: fases completadas y tiempo restante para completar.",
      },
    },
  },
  financial_services: {
    title: "LA MEJOR OPCIÓN EN BRA PARA TU ENTIDAD FINANCIERA",
    section_text_1:
      "El objetivo de toda empresa es obtener ganancias, lograr su visión de sus valores y cumplir su misión.",
    section_text_2:
      "Alcanzar metas, garantizar ingresos y reducir costos son pilares fundamentales para cualquier entidad financiera.",
    section_text_3:
      "Hyaia es la mejor opción para auditar procesos y reglas comerciales, lo que garantiza mayores ganancias en su organización.",

    monitor_account: {
      title: "SEGUIMIENTO POR CUENTA PROPIA",
      section_text_1:
        "Miles de clientes significan miles de procesos, reglas, situaciones, molestias y soluciones.",
      section_text_2:
        "El monitoreo y seguimiento caso por caso, más un sinfín de procesos financieros, con un 100% de eficiencia parece inviable, pero con Hyaia esto es posible.",
    },

    compliance_list: {
      compliance: {
        title: "CUMPLIMIENTO",
        section_text_1:
          "El Riesgo y el Cumplimiento para las instituciones financieras son fundamentos esenciales.",
        section_text_2:
          "Conciliar balances, DRE, índices, endeudamiento, captación de fondos y convertirlos en informes que garanticen la confianza de los accionistas es un trabajo sumamente quirúrgico y minucioso.",
        section_text_3:
          "Con Hyaia generas reportes y cuadros de mando, en tiempo real, sobre toda la cadena operativa y monetaria de tu entidad financiera.",
        section_text_4:
          "Obtenga lo mejor en tecnología de cumplimiento.                ",
      },

      fraud: {
        title: "FRAUDE",
        section_text_1:
          "Ya sea interno o externo, el fraude puede provenir de cualquier lugar, y la mejor opción en la lucha contra el fraude es una tecnología que pueda examinar y monitorear toda su organización, con políticas y reglas que prevengan o detecten cualquier forma de fraude lo antes posible. ",
        section_text_2:
          "Lo mejor en IA antifraude está en Hyaia. Reciba notificaciones de inmediato de cada ocurrencia sospechosa en su organización.",
      },

      customer_plans: {
        title: "PLANES DE CLIENTES",
        section_text_1:
          "Garantice los contratos, tarifas, productos y servicios pactados con sus clientes, manteniéndolos satisfechos y eliminando el grado de evasión.",
        section_text_2:
          "Un cliente feliz vale por dos. El marketing de boca en boca no tiene precio.                ",
      },

      treasury: {
        title: "TESORERÍA",
        section_text_1:
          "Negociaciones y aplicaciones de los recursos financieros de su entidad financiera con mucha más asertividad y previsión.",
        section_text_2:
          "Nuestros módulos no solo aseguran el seguimiento y auditoría de las reglas y procesos de su institución, sino que también predicen escenarios de riesgo a través de la tecnología Deep Learning",
        section_text_3:
          "Más vale prevenir que curar y los beneficios se agradecen.                ",
        section_text_4:
          "No pierdas la oportunidad y cuenta con Hyaia en tu entidad financiera.                ",
      },
    },
  },

  publish_and_share: {
    title: "PUBLICAR, COMPARTIR Y CONTRIBUIR        ",
    section_text:
      "Contribuya a su dashboard a través de su equipo y clientes con enlaces en vivo.",
    send_dashboards: {
      title: "ENVÍE DASHBOARDS EN TIEMPO REAL DURANTE ENLACES EN VIVO",
      section_text:
        "Deje sus dashboards listos y agregue una persona o un equipo a la lista de seguridad del dashboard, serán alertados por correo electrónico de inmediato. Hyaia tiene un sistema de programación, que usted configura para actualizar sus datos y convertirlos en dashboards para espacios regulares o fechas específicas. Su equipo puede acceder a los dashboards en PDF, imágenes o Live Link, una innovación para compartir dashboards completamente interactivos.",
    },
    learn_to_share: {
      title: "APRENDE A COMPARTIR",
      section_text:
        "Muestre sus dashboards de la mejor manera posible compartiéndolos con su equipo, socios y clientes.",
    },

    email_list: {
      by_email: {
        title: "POR E-MAIL",
        section_text:
          "Hyaia entrega sus dashboards por correo electrónico, como archivos adjuntos en formato PDF, Live Link o de imagen.",
      },
      intranet: {
        title: "VÍA INTRANET",
        section_text_1:
          "Agregue sus métricas directamente a su software de colaboración interno.",
        section_text_2: "Use enlaces en vivo como IFRAMES.",
      },
      automatic_reports: {
        title: "INFORMES AUTOMÁTICOS",
        section_text_1:
          "Deje sus informes configurados y comparta sus dashboards con las partes interesadas seleccionadas, según su elección.",
        section_text_2: "Amplíe su productividad.",
      },
    },
  },

  user_security_and_management: {
    title: "SEGURIDAD Y GESTIÓN DE USUARIOS        ",
    section_text:
      "Administre el acceso y los permisos de cada usuario en la plataforma y en sus dashboards.",
    protection: {
      title: "PROTECCIÓN DEL USUARIO Y DEL EQUIPO            ",
      section_text_1:
        "Con Hyaia, usted controla y supervisa el acceso o la gestión de datos, los dashboards y los informes de su equipo.",
      section_text_2:
        "Organice a las personas en equipos, administre sus permisos de acceso a dashboards, reglas y procesos en nuestra área de administración.",
      section_text_3:
        "Desarrolle usuarios para su equipo y clientes. Incluya y mantenga a sus usuarios directamente en Hyaia. Importe hojas de cálculo completas de sus usuarios o use nuestra API en sincronización con Active Directory y LDAP.",
    },
    user_secrty: {
      title: "SEGURIDAD DEL USUARIO            ",
      section_text:
        "Mediante licencias de visor o editor, se puede configurar la plataforma, según el nivel de autorización de cada usuario. Desde la visualización de cuadros de mando, reglas, procesos y políticas corporativas hasta su edición.",
    },

    team_secrty: {
      title: "SEGURIDAD DEL EQUIPO            ",
      section_text:
        "Ordene a sus usuarios en equipos y asigne derechos de acceso para todo el grupo. Migre usuarios entre equipos al instante, asignando diferentes datos y visibilidad a dashboards y reglas.",
    },

    user_params: {
      title: "PARÁMETROS DE USUARIO Y EQUIPO            ",
      section_text:
        "A través de parámetros, filtre automáticamente la información de cada dashboard para el usuario, de acuerdo con los permisos de cada equipo. Los equipos se centran en los conocimientos más relevantes para ellos, sin acceder a los datos de otros usuarios.",
    },
  },

  security: {
    title: "SEGURIDAD AVANZADA        ",
    section_text:
      "Sus datos están seguros y protegidos. Hyaia no funciona con ningún tipo de importación de datos. Usando conexiones VPN, sus datos se leen, se auditan en la base y se convierten en informes y dashboards.",
    company_info: {
      title:
        "SEGURIDAD AVANZADA PARA LOS DATOS, DASHBOARDS E INFORMACIÓN DE SU EMPRESA",
      section_text_1:
        "La protección de sus datos e información es nuestra principal prioridad.",
      section_text_2:
        "Nuestras funciones de seguridad avanzadas le permiten personalizar sus políticas, de acuerdo con los estándares corporativos de su empresa. Integrando tu proveedor e identidad favoritos.",
      section_text_3:
        "La autenticación es uno de los bloqueos de seguridad. Nuestro equipo de Trust Center está cada vez más comprometido en garantizar que los procesos, las personas y las herramientas se mantengan en línea con las normas de seguridad como SOC 1, 2 y 3, ISO 27001 y el respeto a las normas de privacidad como LGPD, GDPR y HIPAA.",
    },
    steps: {
      sso: {
        title: "INICIO DE SESIÓN ÚNICO (SSO)",
        section_text:
          "Facilite que todos los usuarios usen el mismo nombre de usuario y contraseña a través del inicio de sesión único.",
      },
      two_factor: {
        title: "AUTENTICACIÓN DE 2 FACTORES",
        section_text_1:
          "Conéctate a Hyaia a través de tu celular y asegura la protección de tu usuario.",
        section_text_2:
          "A través de la autenticación 2FA, tendrás acceso con una capa más, además de tu nombre y contraseña.",
      },
      tracking_session: {
        title: "SEGUIMIENTO DE SESIÓN",
        section_text_1:
          "Ver todas las actividades de cada usuario. Fíjate cuándo, cómo y qué está haciendo cada uno.",
        section_text_2:
          "Rastree el acceso a su información por usuario, dirección IP, fecha/hora y acción.                ",
      },
      whitelist: {
        title: "WHITELIST POR IP",
        section_text:
          "Nuestra función de lista blanca, por IP, permite que solo ciertas direcciones IP puedan acceder a sus dashboards o aplicaciones.",
      },
      log_tracing: {
        title: "ANÁLISIS DE REGISTRO INTELIGENTE",
        section_text:
          "Analizamos el uso de inicio de sesión y bloqueamos automáticamente las cuentas con repetidos intentos fallidos o ubicaciones no aprobadas por usted.",
      },
      password_rules: {
        title: "REGLAS DE CONTRASEÑA",
        section_text:
          "Contraseñas seguras, inteligentes y complejas que se alternan con frecuencia. Tamaño mínimo de caracteres, letras mayúsculas y minúsculas, símbolos, números y todas las opciones.",
      },
    },

    rest_api: {
      title: "UNA API BASADA EN REST SIMPLE Y SEGURA",
      section_text:
        "Simples y potentes son las API de Hyaia. A usted, que es el desarrollador, le encantará trabajar con nuestra API, creando aplicaciones innovadoras, interfaces rápidas que amplían su interfaz de usuario para incluir dashboards. Todo lo que necesita está en nuestra referencia de API en línea, hasta un área creativa de punto final.",
    },
  },

  awards: {
    title: "PREMIOS",
    section_text:
      "Estamos comprometidos en ofrecer siempre soluciones de calidad y seguras a nuestros clientes. Por eso somos reconocidos como la mejor tecnología multisectorial del mundo en Business Revenue Assurance. Y enumeramos con orgullo nuestros premios:        ",
  },

  whitelabel: {
    title: "WHITE LABEL DASHBOARDS        ",
    section_text:
      "Benefíciese de los servicios y aplicaciones White Label (OEM) de Hyaia y hágalo parte de su negocio.",
    dashboard: {
      title: "AÑADE DASHBOARDS WHITE LABEL DONDE QUIERAS",
      section_text_1:
        "Elimine cualquier mención de la marca Hyaia y reemplácela con la de su empresa con nuestra función de White Label.",
      section_text_2:
        "Deleite a sus clientes y equipo con análisis directamente desde su aplicación y sitio web.",
    },
    in_your: {
      crm: {
        title: "EN TU PLATAFORMA CRM",
        section_text:
          "Aproveche su CRM de ventas y servicios al permitir que sus usuarios vean dashboards personalizados creados exclusivamente para ellos. Ofrézcales más personalización, flexibilidad y dashboards atractivos.",
      },
      erp: {
        title: "EN TU PLATAFORMA ERP",
        section_text:
          "¿Tu ERP no proporciona excelentes informes? Agrega cuadros de mando personalizados con datos de tu ERP, cruzados con otras bases de datos, para sacar el máximo partido a tu sistema.",
      },
      portal: {
        title: "EN TU PORTAL                ",
        section_text:
          "Tan fácil como copiar y pegar, la integración del dashboards de Hyaia es para usted que usa SharePoint u otro software como solución para su portal interno.",
      },

      site: {
        title: "EN TU SITIO WEB                ",
        section_text_1: `¿Necesita gráficos dinámicos en su sitio web? ¿O un KPI para tu número de "me gusta" y visitas?`,
        section_text_2:
          "Con Hyaia y nuestros enlaces públicos en vivo, dé a su web un aspecto analítico.",
      },

      views: {
        title: "VISTAS INTEGRADAS",
        section_text:
          "Incruste dashboards interactivos y dinámicos directamente desde su portal o aplicación web a través de nuestros enlaces en vivo en momentos. Copie y pegue nuestro código iFrame directamente en su sitio web y prepárese para agregar dashboards a su aplicación.",
      },

      app: {
        title: "EN SU APLICACIÓN PERSONALIZADA                ",
        section_text:
          "¿Tiene una excelente aplicación en la nube B2B pero no puede crear un módulo de informes a su alrededor? Agregue Hyaia a su aplicación, a través de iFrames y API, e impresione a sus clientes con sus presentaciones.",
      },
      sso: {
        title: "INICIO DE SESIÓN ÚNICO (SSO)",
        section_text:
          "A través del conector de Active Directory o la integración de SAML, haga que el tiempo de sus usuarios sea mucho más fácil al habilitar el inicio de sesión único. Utilice también nuestra API para sincronizar usuarios desde su aplicación personalizada a Hyaia y viceversa.",
      },
      two_way: {
        title: "INTERACCIONES BIDIRECCIONALES",
        section_text:
          "Con su aplicación de CRM, haga clic en un gráfico, seleccione el cliente para ver todas las órdenes de venta del mismo. La interacción bidireccional pasa parámetros entre los dashboards de Hyaia y su aplicación.",
      },
    },
  },

  privacy_policy: {
    main_section: {
      first_tilte: "POLÍTICAS",
      second_title: "DE PRIVACIDAD",
      text: "Respetamos tus datos. Nuestro negocio es garantizar que sus datos permanezcan seguros, privados y protegidos. Desde un visitante del sitio web hasta un cliente a largo plazo, esta es nuestra política de privacidad y cookies.",
    },
    introduction_section: {
      title: "INTRODUCCIÓN",
      paragraph_1: "Su privacidad es de suma importancia para Hyaia SAAS.",
      paragraph_2:
        "Hyaia proporciona un servicio basado en la nube (el “Servicio”), que es una plataforma de informes y análisis de datos para almacenar, procesar, interconectar y visualizar datos a través de nuestra plataforma web, API y aplicaciones móviles.",
      paragraph_3:
        "Respetamos completamente su derecho a la privacidad con respecto a sus interacciones con el Servicio y estamos comprometidos a ser transparentes en nuestro trato con usted, sobre qué información personal recopilamos y cómo usamos su información personal.",
      paragraph_4:
        "Además, solo recopilamos y usamos la información personal que es necesaria para proporcionar servicios para los cuales tenemos una base legal para hacerlo.",
      paragraph_5:
        "Hemos creado esta Política de privacidad para describir nuestras prácticas y procedimientos en el manejo de la “Información personal” que recopilamos o recibimos de usted.",
      paragraph_6:
        "El término “Información personal” significa cualquier información que identifique, relacione, describa o pueda asociarse con, o pueda vincularse razonablemente, directa o indirectamente, a una persona física viva identificada o identificable, incluidos, entre otros: ( i) Identificadores como nombre real, seudónimo, dirección postal, identificador personal único, dirección IP, dirección de correo electrónico, nombre de cuenta e (ii) información definida como “información personal”, “información de identificación personal”, “datos personales”, o similar expresiones bajo las leyes de privacidad aplicables o las leyes de seguridad de datos, que incluyen el Reglamento General de Protección de Datos (GDPR) de la Unión Europea, entre otros.",
      paragraph_7:
        "Esta Política de Privacidad cubre tres tipos de información personal:",
      list: {
        item_1:
          "“Información del sitio” se refiere a la información recopilada al ver páginas en nuestros sitios web, la información que ha ingresado en nuestro contacto, los documentos descargados, las solicitudes de empleo u otros formularios, las URL de referencia y la dirección IP y datos similares rastreados tanto internamente como por terceros;",
        item_2:
          "“Información relacionada con la cuenta” se refiere a la información de contacto, información de pago e información biográfica sobre los representantes y contactos de nuestros clientes utilizados para marketing, apertura de nuevas cuentas de usuario para usar nuestros Servicios y para mantener cuentas existentes;",
        item_3:
          "“Datos de contenido de usuario de la cuenta” se refiere a los datos que usted o sus usuarios pueden realizar, cargar, conectar, transferir, ingresar o importar en Hyaia para fines de uso o del Servicio.",
      },
      paragraph_8:
        "Lea atentamente esta Política de privacidad. Le pediremos su consentimiento para estar sujeto a esta Política de privacidad como condición para: (i) ver nuestros sitios web y (ii) probar o usar nuestros servicios.",
      paragraph_9:
        "Nuestro sitio web y servicios están destinados a profesionales y adultos. No recopilamos información personal de usuarios menores de 13 años, pero ponemos nuestros servicios a disposición de instituciones académicas.",
    },
    colected_data_section: {
      title: "INFORMACION RECOLECTADA",
      sub_section_1: {
        sub_title: "Cookies del sitio web",
        paragraph_1:
          "Una cookie es un pequeño archivo colocado en su navegador que nos permite mejorar su experiencia en los sitios web y aplicaciones de Hyaia al recordar sus preferencias y configuraciones.",
        paragraph_2:
          "Las cookies de Hyaia se utilizan para almacenar el idioma del sitio web preferido/seleccionado, el sitio web que remite al visitante, un identificador único que se puede rastrear hasta la sesión en la aplicación para informar sobre actividades o para patrones predefinidos, como preferencias de región e idioma.",
        paragraph_3:
          "Además, nuestro sitio web utiliza Google Analytics mediante Tag Manager, que realiza un seguimiento de los visitantes, la actividad de página a página y la duración de cada página. Utilizamos estas cookies para mejorar nuestro sitio web en términos de contenido y organización y para indexarlo preferentemente en la búsqueda de Google.",
      },
      sub_section_2: {
        sub_title: "Formularios del sitio web",
        paragraph_1:
          "Los formularios del sitio web se utilizan para permitir que los visitantes se comuniquen con el equipo de ventas para consultas comerciales, solicitudes de trabajo y para enviar solicitudes de información adicional o documentos sobre temas relacionados.",
      },
      sub_section_3: {
        sub_title: "Detalles del propietario de la cuenta principal",
        paragraph_1:
          "Los usuarios que se registren en el estudio y/o paguen suscripciones deben ingresar una dirección de correo electrónico válida, nombre y apellido, nombre comercial y número de teléfono según los Términos de uso.",
        paragraph_2:
          "Los usuarios que no deseen ingresar correctamente la información anterior no están autorizados a utilizar nuestro Servicio.",
        paragraph_3:
          "Esta información se recopila y almacena con la cuenta para notificar cambios en el servicio y para identificar al propietario de la cuenta en caso de violación de datos, uso indebido de datos u otros problemas relacionados con el uso del Servicio.",
      },

      sub_section_4: {
        sub_title: "Datos de usuario de la cuenta",
        paragraph_1:
          "Usuarios que se conectan, envían o ingresan datos en Hyaia para elanálisis durante el uso del Servicio tienen como objetivo la total privacidad de sus datos.",
        paragraph_2:
          "Hyaia se adhiere a una sólida Política de privacidad para todos sus empleados y socios. Esta política, en esencia, prohíbe acceder a los datos sin el permiso expreso del usuario. Este permiso se registra y su acceso a la cuenta también se registra y es visible para el propietario de la cuenta.",
        paragraph_3:
          "El contenido de los datos no es responsabilidad de Hyaia, ni podemos interpretar estos datos, sus orígenes y su uso. Cuando se proporciona acceso a la cuenta, nuestra responsabilidad es ayudar a nuestros clientes a resolver el problema.",
        paragraph_4:
          "No transmitimos, copiamos ni movemos datos de la región del Centro de datos original a ninguna otra región o base de datos. No permitimos el acceso a los datos excepto al equipo de soporte técnico de Microsoft Azure en caso de problemas con el sistema o la base de datos y siempre supervisado por el equipo de Hyaia.",
      },

      sub_section_5: {
        sub_title: "Detalles de pago de la cuenta",
        paragraph_1:
          "El propietario principal de la cuenta, al usar nuestros servicios pagos, debe agregar un método de pago.",
        paragraph_2:
          "Todos los demás datos, como el nombre de la empresa, la dirección de facturación, el IVA (Impuesto sobre el Valor Añadido, o TVA en francés) o los números de identificación fiscal, los identificadores de la empresa son necesarios para las prácticas contables y se utilizan como tales.",
      },
    },

    data_use_section: {
      title: "USO DE DATOS RECOPILADOS",
      paragraph_1:
        "Los datos recopilados en el sitio web se utilizan para optimizarlo, cambiando la estructura y el contenido.",
      paragraph_2:
        "Los datos de formularios como Contáctenos, Empleo, Visión y hoja de ruta, Registro de blog, Descarga de activos como Whitepapers y Documentos se utilizan para proporcionar la información requerida al solicitante.",
      paragraph_3:
        "Los datos de usuario de la cuenta se utilizan para enviar boletines de productos, notificaciones del sistema, alertas, publicaciones programadas por los usuarios o el sistema según sea necesario, pero no exclusivamente para restablecer contraseñas, límites del sistema, pagos y facturas, nuevos lanzamientos de productos, actualizaciones o tiempo de inactividad, alertas de seguridad y alertas similares.",
    },

    gdpr_section: {
      title: "GDPR",
      paragraph_1:
        "Si usted es una persona en el Espacio Económico Europeo, puede tener los siguientes derechos bajo la ley de protección de datos aplicable y nosotros como Controlador de datos en relación con la Información relacionada con la cuenta u otra Información personal cubierta por esta Política de privacidad, con tales derechos en relación a dicha información personal:",
      list: {
        item_1:
          "el derecho a acceder a la información personal relacionada con usted;",
        item_2:
          "el derecho a corregir cualquier error en su información personal;",
        item_3:
          "el derecho a oponerse y pedirnos que dejemos de comunicarnos con usted con marketing directo;",
        item_4:
          "derechos en relación con el tratamiento automatizado de datos;",
        item_5:
          "el derecho a restringir o impedir que se procese su información personal;",
        item_6:
          "el derecho a que su información personal sea transferida a otro controlador de datos;",
        item_7: "el derecho a borrar;",
        item_8:
          "el derecho a presentar una queja ante el DPC si cree que no hemos manejado su información personal de acuerdo con la ley de protección de datos aplicable.",
      },
      paragraph_2:
        "Si es un usuario que trabaja en nombre de un cliente existente de Hyaia y tenemos información relacionada con su cuenta, en virtud de un contrato con ese cliente, tenemos un interés legítimo en enviarle comunicaciones electrónicas/marketing directo relacionado con el Servicio y asuntos relacionados ( que puede incluir, entre otros, boletines informativos, anuncios de nuevas características, etc.).",
      paragraph_3:
        "También podemos hacer preguntas para diferentes Servicios, incluida la competencia. Y podemos pedirle que complete encuestas que usamos con fines de investigación, aunque no es necesario que las complete. Puede pedirnos que dejemos de comunicarnos con usted con fines de marketing directo.",
      paragraph_4:
        "Si desea hacer esto, envíe un correo electrónico a support@hyaia.com directamente o llame a uno de los números disponibles en el sitio web. También puede hacer clic en el botón “Cancelar suscripción” en la parte inferior de la comunicación electrónica.",
      paragraph_5:
        "Puede tomar hasta quince (15) días para que esto ocurra; y háganos saber el método de contacto con el que no está satisfecho. Y si no está satisfecho con ciertas formas de contactarlo (por ejemplo, puede estar feliz de ser contactado por correo electrónico pero no por teléfono).",
    },

    protector_structure_section: {
      title: "ESTRUCTURA DE GUARDIA DE PRIVACIDAD UE-EE.UU.",
      paragraph_1:
        "Como tiene la opción de almacenar los datos en un centro de datos en la UE o los USA, no nos adherimos a la EU-U.S. Privacy Shield ya que no se aplica. Sus datos, si los almacena en la UE, permanecerán en la UE.",
    },

    retention_section: {
      title: "RETENCIÓN DE DATOS",
      paragraph_1:
        "La información relacionada con la cuenta y otra información personal se retendrán y almacenarán durante el período de tiempo que consideremos necesario, teniendo en cuenta el propósito comercial para el que se recopiló en primera instancia (es decir, administrar su cuenta mientras su cuenta está activa y un período razonable posterior si decide reactivar su cuenta) y nuestras obligaciones según la ley de protección de datos aplicable.",
      paragraph_2:
        "Esto puede incluir retener información relacionada con la cuenta u otra Información personal según sea necesario para cumplir con nuestras obligaciones legales, resolver disputas, hacer cumplir nuestros contratos, respaldar las operaciones comerciales y continuar desarrollando y mejorando nuestros Servicios.",
      paragraph_3:
        "Cuando seguimos mejorando y desarrollando información personal para los servicios, tomamos medidas para eliminar la información que lo identifica directamente, y solo usamos la información para descubrir información colectiva sobre su uso de nuestro Servicio, no para analizar específicamente sus características personales.",
    },

    contact_section: {
      title: "ESTAR EN CONTACTO",
      paragraph_1:
        "Si necesita comunicarse con nosotros con respecto a cualquiera de sus derechos establecidos en esta Política, todas las solicitudes deben realizarse por escrito y por correo electrónico a support@hyaia.com.",
    },

    resolution_section: {
      title: "RESOLUCIÓN DE CONFLICTOS",
      paragraph_1:
        "Si cree que no hemos procesado su información personal de acuerdo con esta Política de privacidad, comuníquese con nosotros en primera instancia. Puede enviarnos una queja a support@hyaia.com.",
      paragraph_2:
        "Una vez que recibamos una queja de privacidad, nuestro equipo de privacidad investigará su queja y le dará una respuesta.",
      paragraph_3:
        "Necesitaremos suficiente información para que podamos evaluar su queja y, como resultado, podemos pedirle que nos proporcione información adicional que creemos que es necesaria para evaluar su queja.",
      paragraph_4: "El proceso de resolución de disputas será en inglés.",
    },

    alterations_section: {
      title: "CAMBIOS A LA POLÍTICA DE PRIVACIDAD",
      paragraph_1:
        "Hyaia puede cambiar su Política de privacidad de vez en cuando ya su entera discreción. La fecha de las revisiones más recientes aparecerá en esta página.",
      paragraph_2:
        "Si no está de acuerdo con estos cambios, no continúe utilizando el Servicio para enviarnos información relacionada con la cuenta u otra información personal.",
      paragraph_3:
        "Si se realizan cambios importantes en la Política de privacidad, se lo notificaremos mediante la publicación de un aviso destacado en nuestro sitio web o mediante el envío de un aviso en relación con el mismo.",
      paragraph_4:
        "No procesaremos información relacionada con la cuenta de una manera que no esté cubierta por esta Política de privacidad sin su consentimiento.",
    },

    original_section: {
      title: "POLÍTICAS DE PRIVACIDAD ORIGINALES",
      paragraph_1:
        "Este documento en portugués es gratuito para traducir y no se superpone con el documento original, utilizado solo para ayudar a la comprensión de nuestros clientes. Las preguntas sobre estas políticas deben dirigirse a support@hyaia.com.",
    },
  },

  terms_of_use: {
    main_section: {
      first_tilte: "TÉRMINOS",
      second_title: "de Uso",
      paragraph_1:
        "En este documento se describen las condiciones de uso de nuestro servicio, nuestras obligaciones y si acepta utilizar nuestra plataforma, como prueba o como cliente.",
      paragraph_2:
        "Es muy importante que los lea y nos haga saber sus dudas e inquietudes.",
    },
    terms_section: {
      title: "TÉRMINOS",
      paragraph_1:
        "Estos términos de uso (“Términos”) cubren su uso (“usted” y “Cliente”) y el acceso a nuestros servicios, software de cliente y sitios web (colectivamente como “Servicios”) a partir del 1 de enero de 2020.",
      paragraph_2:
        "Al aceptar estos Términos, ya sea registrándose en nuestros sitios web, registrándose para una prueba gratuita o comprando una de nuestras suscripciones, haciendo clic en un cuadro que indica su aceptación, o ejecutando un formulario de pedido o cualquier otra documentación que haga referencia a este acuerdo, usted acepta los términos de este acuerdo.",
      paragraph_3:
        "Si está celebrando este acuerdo en nombre de una empresa u otra entidad legal, declara que tiene la autoridad para vincular a dicha entidad y sus afiliadas a estos términos y condiciones, en cuyo caso los términos “usted” o “su” se refieren a dicha entidad y sus afiliados.",
      paragraph_4:
        "Si no tiene esa autoridad o si no está de acuerdo con estos términos y condiciones, no debe aceptar este acuerdo y no podrá utilizar nuestros Servicios.",
      paragraph_5: {
        first_text: "Nuestra ",
        link_text: "Política de Privacidad",
        second_text:
          " explica cómo recopilamos y usamos su información cuando usa nuestros Servicios. Al utilizar nuestros Servicios, usted acepta estar sujeto a estos Términos y nuestra Política de privacidad.",
      },
      paragraph_6:
        "Nuestro acuerdo de procesamiento de datos (DPA) es una extensión de los Términos y explica nuestro papel como Procesador de datos, nuestras obligaciones y responsabilidades entre nosotros. Al utilizar nuestros Servicios, usted acepta estar sujeto a estos Términos y al DPA.",
    },
    update_use_terms_section: {
      title: "ACTUALIZACIONES DE LOS TÉRMINOS DE USO",
      paragraph_1:
        "Hyaia se reserva el derecho de actualizar y cambiar los Términos de uso en cualquier momento y sin previo aviso.",
      paragraph_2:
        "Todas las funciones nuevas que aumenten o mejoren el Servicio actual, incluido el lanzamiento de nuevas herramientas y funciones, estarán sujetas a los Términos de uso. Su uso continuado del Servicio después de dichos cambios constituirá su consentimiento a dichos cambios.",
      paragraph_3:
        "Los Términos de uso establecen el entendimiento completo entre usted y Hyaia con respecto al Servicio y reemplazan cualquier acuerdo anterior entre las partes (incluidas, entre otras, versiones anteriores de los Términos de servicio).",
    },
    services_section: {
      title: "SERVICIOS",
      paragraph_1: "Nuestros servicios permiten al cliente:",
      list: {
        item_1:
          "almacenar datos que elija transferir a nuestras bases de datos y servidores;",
        item_2:
          "editar, transformar, combinar, modificar datos para crear vistas o datos adicionales;",
        item_3:
          "crear informes y dashboards a partir de los datos proporcionados;",
        item_4:
          "publique los informes y dashboards junto con los datos para otros usuarios o el público.",
      },
      paragraph_2:
        "Podemos eliminar, suspender temporalmente, modificar y agregar cualquiera y todos los servicios sin previo aviso.",
      paragraph_3:
        "Su uso del Servicio, incluido cualquier contenido, información o funcionalidad contenida en el mismo, se proporciona “tal cual” y “según disponibilidad”, sin representaciones ni garantías de ningún tipo, expresas o implícitas, incluidas, entre otras, las garantías implícitas de comerciabilidad, idoneidad para un propósito particular y no infracción. Usted asume toda la responsabilidad y el riesgo por su uso de este Servicio.",
      paragraph_4:
        "Nuestros Servicios permiten el archivo o la eliminación de datos en ciertos intervalos de tiempo y según el nivel de suscripción. Hyaia no es responsable de ninguna pérdida de datos y no debe considerarse una copia de seguridad de datos críticos.",
      paragraph_5:
        "Nuestros Servicios incluyen funciones que le permiten conectarse a datos, sitios web, aplicaciones y servicios de terceros. Hyaia no es responsable del uso de productos proporcionados por terceros, ni Hyaia estará afiliada con ninguno de los terceros.",
      paragraph_6:
        "Puede seleccionar diferentes tipos de suscripciones y cada una puede tener diferentes características y funciones que pueden cambiar con el tiempo.",
      sub_section_1: {
        title: "a) Suscripciones personales, gratuitas y de prueba",
        paragraph_1:
          "Hyaia puede ofrecer suscripciones que permitan un uso limitado del Servicio en funcionalidad o duración. Los usuarios de estas suscripciones pueden estar sujetos a publicidad, funcionalidad limitada y reducción de Servicios y/o límites en la capacidad de datos.",
        paragraph_2:
          "Estas suscripciones pueden eliminarse para liberar espacio para otras cuentas si no se usan activamente durante un cierto período de tiempo.",
        paragraph_3:
          "Estas suscripciones pueden cancelarse en cualquier momento y sin previo aviso si se violan estos Términos.",
      },
      sub_section_2: {
        title:
          "b) Suscripciones sin fines de lucro o de uso académico únicamente",
        paragraph_1:
          "Hyaia puede ofrecer suscripciones gratuitas o a un costo reducido, que permiten el uso académico y sin fines de lucro de nuestros Servicios con funcionalidad limitada.",
        paragraph_2:
          "Los usuarios de esta suscripción pueden estar sujetos a publicidad, funcionalidad limitada y reducción de servicios y/o límites en la capacidad de datos, a menos que haya componentes de pago de su suscripción.",
        paragraph_3:
          "Estas plantillas de cuenta se pueden eliminar para dejar espacio para otras cuentas si no se usan activamente durante un cierto período de tiempo.",
      },
      sub_section_3: {
        title: "c) Suscripciones pagadas",
        paragraph_1:
          "Hyaia ofrece servicios pagos que le permiten utilizar el Servicio. Los usuarios de este Servicio tendrán diferentes características dependiendo de su nivel de suscripción.",
        paragraph_2:
          "Existen varios niveles de servicio, dependiendo del grado y acuerdo entre el Cliente y Hyaia. En general, los niveles más básicos tienen menor rendimiento, almacenamiento y capacidad que los niveles superiores; sin embargo, pueden cambiar con el tiempo y pueden reemplazarse o modificarse caso por caso.",
      },
      sub_section_4: {
        title: "d) Funcionalidad adoptada anticipadamente",
        paragraph_1:
          "A veces lanzamos productos y funciones que aún se están probando y evaluando. Estos Servicios se marcarán como beta, vista previa, acceso anticipado o evaluación (o con palabras o frases similares) y es posible que no sean tan confiables como otros servicios. Úselos bajo su propio riesgo.",
      },
    },
    software_section: {
      title: "SOFTWARE",
      paragraph_1:
        "Algunos de nuestros Servicios le permiten descargar software de cliente (“Software”), que puede actualizarse automáticamente. Siempre que cumpla con estos Términos, le otorgamos una licencia limitada, no exclusiva, intransferible y revocable para usar el Software únicamente para acceder a los Servicios.",
      paragraph_2:
        "En la medida en que cualquier componente del Software pueda ofrecerse bajo una licencia de código abierto, ponemos esa licencia a su disposición y las disposiciones de esta licencia pueden reemplazar expresamente algunos de estos Términos.",
      paragraph_3:
        "A menos que las siguientes restricciones estén prohibidas por ley, usted acepta no aplicar ingeniería inversa ni descompilar los Servicios, intentar hacerlo ni ayudar a nadie a hacerlo.",
    },
    content_section: {
      title: "CONTENIDO",
      paragraph_1:
        "Al utilizar nuestros Servicios, puede almacenar archivos y datos, así como metadatos (“Contenido”). Estos Términos no nos otorgan el derecho de acceder, usar o distribuir su Contenido a menos que sea necesario para proporcionar el Servicio.",
      paragraph_2:
        "Nuestros Servicios también brindan funciones como búsqueda, detección de metadatos o vinculación. Estas y otras características pueden requerir que nuestros sistemas accedan, almacenen y digitalicen el Contenido.",
      paragraph_3:
        "Usted nos da permiso para llevar a cabo los procesos, y ese permiso se extiende a nuestros afiliados y terceros de confianza con los que trabajamos.",
      paragraph_4:
        "Nuestros Servicios le permiten compartir su contenido con otros a través de dashboards y datos a través de Live Links y funciones similares. No publicamos en su nombre y no controlamos a los destinatarios de su contenido.",
    },
    use_section: {
      title: "USO ACEPTABLE",
      paragraph_1:
        "A continuación se describen las acciones que constituyen un uso inaceptable de nuestro Servicio y darán como resultado la cancelación y eliminación inmediatas de su cuenta y todo el contenido de nuestro Servicio sin previo aviso, notificación, reembolso o crédito de los montos ya pagados:",
      list: {
        item_1:
          "Utilizar los Servicios para fomentar actividades ilegales, abusivas o de otro tipo que interfieran con los negocios o actividades de Hyaia y/o de otros clientes;",
        item_2:
          "Intentar eludir o interrumpir cualquier mecanismo de seguridad en cualquiera de los Servicios o utilizar los Servicios de una manera que represente un riesgo de seguridad o de servicio para Hyaia o uno de sus usuarios;",
        item_3:
          "Aplicar ingeniería inversa a los Servicios para encontrar limitaciones, vulnerabilidades u omitir funciones de filtrado;",
        item_4:
          "Usar los Servicios de una manera que pueda exponer a Hyaia o a terceros a responsabilidad, daño o peligro;",
        item_5:
          "Lanzar o facilitar, ya sea intencionalmente o no, un ataque de denegación de servicio a cualquiera de los Servicios o cualquier otra conducta que afecte negativamente la disponibilidad, confiabilidad o estabilidad de los Servicios;",
        item_6:
          "Transmitir cualquier material que contenga virus, “Caballos de Troya”, gusanos u otros programas maliciosos, dañinos o peligrosos;",
        item_7:
          "Usar los Servicios para participar o conectarse con actividades fraudulentas;",
        item_8:
          "Usar los Servicios en contra de cualquier política de privacidad, incluidas, entre otras, HIPAA, PIPEDA y GDPR;",
        item_9:
          "Violar o facilitar la violación de cualquier ley o reglamento local, regional, provincial, estatal, federal o extranjero, incluidas las leyes y reglamentos relacionados con la transmisión de datos o software;",
        item_10:
          "Tomar cualquier acción para participar, alentar o promover cualquier actividad prohibida bajo estos Términos de uso;",
        item_11:
          "Usar el Servicio para enviar correos electrónicos masivos o spam a terceros sin su consentimiento o no de acuerdo con CAN-SPAM y guías similares;",
        item_12:
          "Utilizar los Servicios para almacenar o transmitir cualquier material que infrinja los derechos de propiedad intelectual u otros derechos de terceros;",
        item_13:
          "Usar los Servicios para almacenar o transmitir cualquier material que sea calumnioso, difamatorio, discriminatorio o malicioso o dañino para cualquier persona o entidad;",
        item_14:
          "Usar los Servicios o cualquier componente de los Servicios de una manera no autorizada por Hyaia;",
        item_15:
          "Suplantar a otros usuarios sin permiso o acceder a cualquier área de la Plataforma a la que no tenga permiso para acceder.",
      },
      paragraph_2:
        "Usted y su empresa son responsables de su conducta y contenido y deben cumplir con todos los términos de uso aceptables anteriores.",
      paragraph_3:
        "Podemos revisar su conducta y contenido para verificar el cumplimiento y estos términos. Dicho esto, no tenemos ninguna obligación de hacerlo.",
      paragraph_4:
        "Proteja su contraseña para los Servicios, asegúrese de que otros no tengan acceso a ella y mantenga actualizada la información de su cuenta.",
      paragraph_5:
        "Finalmente, nuestros Servicios no están destinados y no pueden ser utilizados por personas menores de 13 años. Al usar nuestros Servicios, usted nos declara que tiene 13 años de edad o más.",
    },
    communication_section: {
      title: "COMUNICACIÓN",
      paragraph_1:
        "Debe proporcionar su nombre completo, una dirección de correo electrónico válida y otra información necesaria para completar el proceso de inscripción y activación. Las direcciones de correo electrónico, los nombres o la información de la empresa no válidos no constituyen un uso aceptable de los Servicios.",
      paragraph_2:
        "Sin perjuicio de nuestra Política de privacidad, y con el fin de brindarle el Servicio, Hyaia puede comunicarse con usted por correo electrónico o por teléfono con respecto a su cuenta, actualizaciones, noticias y otros asuntos relacionados con su cuenta. Consulte nuestra Política de Privacidad para obtener información adicional.",
      paragraph_3:
        "Usted es responsable de mantener la seguridad de su cuenta y contraseña. Hyaia nunca le pedirá su contraseña ni le proporcionará su contraseña por correo electrónico o cualquier otro medio de comunicación.",
    },
    host_section: {
      title: "ALOJAMIENTO",
      paragraph_1:
        "Usted comprende que Hyaia utiliza proveedores externos y socios de alojamiento para proporcionar el hardware, el software, la información, la red, el almacenamiento y la tecnología relacionada necesaria para ejecutar el Servicio.",
      paragraph_2:
        "Nuestros servicios están alojados o dependen de los siguientes proveedores:",
      list: {
        item_1:
          "Microsoft Corporation One Microsoft Way Redmond, WA 98052-7329 USA",
        item_2: "OVH 2 Rue Kellermann 59100 Roubaix France",
      },
    },
    service_availability_section: {
      title: "SERVICIO DISPONIBLE",
      paragraph_1:
        "Hyaia se esforzará por hacer que el Servicio esté disponible el 99,5 % del año, pero no garantiza a menos que se documente lo contrario a través de un acuerdo de Cliente comercial que anula estos Términos.",
      paragraph_2:
        "Hyaia no será responsable de ninguna pérdida de datos, negocios, ingresos o propiedad debido a que el Servicio no está disponible.",
      paragraph_3:
        "Las fallas inesperadas causadas por terceros, incluidos Microsoft Azure, OVH, Amazon y Google, utilizados por nuestra infraestructura, así como cualquier software o servicio al que nos conectemos, no cuentan para nuestras métricas de disponibilidad del Servicio.",
      paragraph_4:
        "Previa solicitud, podemos, a nuestra discreción, proporcionar más detalles de la interrupción del Servicio en forma de Informe de Interrupción del Servicio (SIR). Un SIR puede emitirse de manera limitada o puede no contener información de seguridad y/o de propiedad exclusiva.",
    },
    support_service_section: {
      title: "SERVICIO DE SOPORTE",
      paragraph_1:
        "Hyaia se esfuerza por brindar asistencia a todos los Clientes, dentro de un período de tiempo aceptable, pero no garantiza esto, a menos que se documente lo contrario a través de un Acuerdo de nivel de servicio específico, que anula la totalidad o parte de los Términos.",
    },
    clossing_section: {
      title: "CLAUSURA",
      paragraph_1:
        "Usted es libre de dejar de usar nuestros servicios en cualquier momento. También nos reservamos el derecho de suspender o cancelar los Servicios en cualquier momento, a nuestro exclusivo criterio y sin previo aviso.",
      paragraph_2:
        "Por ejemplo, podemos suspender o rescindir su uso de los Servicios si no cumple con estos Términos o si usa los Servicios de una manera que podría hacernos responsables legalmente, interrumpir los Servicios o interrumpir el uso de los Servicios por parte de un tercero. Servicios.",
      paragraph_3:
        "A excepción de las suscripciones pagas, nos reservamos el derecho de cancelar y eliminar su cuenta si no accede a nuestros Servicios después de un cierto período de tiempo.",
      paragraph_4:
        "Hyaia le enviará un aviso a través de la dirección de correo electrónico asociada con su cuenta antes de que lo hagamos. No somos responsables de la correcta recepción del correo electrónico debido a spam, reglas, firewall o notificaciones de desactivación.",
      paragraph_5:
        "Nos reservamos el derecho de aceptar o rechazar a un cliente. Tenemos la discreción exclusiva de permitir o no el registro, la renovación, el cambio de plan o el uso de nuestros servicios.",
      paragraph_6:
        "Para cancelar una cuenta, debe comunicarse directamente con el equipo de Hyaia por correo electrónico o por teléfono. Utilice la dirección de correo electrónico support@hyaia.com para cancelar su cuenta.",
      paragraph_7:
        "Su suscripción paga permanecerá vigente hasta que (i) se cancele, o (ii) se rescinda según estos Términos, o (iii) no se reciba el pago al final de cada ciclo de renovación de pago.",
      paragraph_8:
        "La cancelación de su cuenta es inmediata y resultará en la pérdida permanente de sus datos.",
      paragraph_9:
        "Hyaia no podrá restaurar la cuenta después de un cierto período de tiempo ni recuperar ninguno de sus datos. No se otorgarán créditos ni reembolsos en caso de cancelación iniciada por el Cliente, antes del final del período de facturación/período de suscripción.",
    },
    downgrade_section: {
      title: "Downgrade",
      paragraph_1:
        "Algunas suscripciones se pueden degradar a un nivel inferior siempre que la suscripción no exceda los límites de uso o las funciones disponibles, solo el nivel de suscripción utilizado. Las suscripciones que no cumplan con los requisitos del nuevo grado de suscripción objetivo permanecerán en la suscripción actual.",
      paragraph_2:
        "No es responsabilidad de Hyaia asegurarse de que se cumplan los requisitos antes de cambiar la suscripción. Los registros deben modificarse antes del final del ciclo de facturación y entrarán en vigencia inmediatamente después de la modificación.",
      paragraph_3:
        "No se otorgarán reembolsos ni créditos por suscripciones que permanezcan en su nivel de suscripción si exceden los límites de uso del nivel de suscripción deseado.",
      paragraph_4:
        "No se otorgarán reembolsos ni créditos por funciones prepagas no utilizadas o límites agregados al nivel de suscripción inicial. Los datos y la funcionalidad pueden ocurrir al degradar las suscripciones, así que tenga cuidado antes de degradar.",
      paragraph_5:
        "Algunos niveles de suscripción no se pueden degradar, solo cancelar.",
    },
    upgrade_section: {
      title: "Upgrade",
      paragraph_1:
        "Las opciones adicionales o actualizaciones que causen un aumento de las tarifas se cargarán a su tarjeta de crédito y entrarán en vigencia de inmediato. No todos los niveles de suscripción se pueden actualizar o cambiar sus opciones.",
    },
    prices_section: {
      title: "PRECIOS Y PAGO",
      paragraph_1:
        "Los precios de todos los Servicios, incluidas, entre otras, las tarifas del plan de suscripción del Servicio, están sujetos a cambios sin previo aviso. Habiendo dicho lo anterior, intentaremos notificar a todos los clientes con al menos treinta (30) días de anticipación por correo electrónico.",
      paragraph_2:
        "Los métodos de pago aceptables son mediante transferencia bancaria, tarjeta de crédito o PayPal. Pago por cheque bancario acordado por ambas partes solamente.",
      paragraph_3:
        "Todos los demás métodos de pago serán rechazados y no constituyen pago. Si paga con tarjeta de crédito o PayPal y dependiendo de su ubicación, el pago será manejado por un procesador de pagos de EE. UU. o un procesador de pagos europeo.",
      paragraph_4:
        "Usted es responsable de todos los impuestos aplicables, tarifas bancarias, tarifas de transferencia, tarifas de tarjetas de crédito, tarifas de cambio de moneda, impuestos federales, regionales, estatales, locales o cualquier recargo y recargo similar impuesto en o en relación con nuestros Servicios.",
      paragraph_5:
        "A los efectos de esta sección, los impuestos no incluyen los impuestos obligatorios o medidos por el impuesto sobre la renta, el impuesto sobre la propiedad o el impuesto sobre la nómina de Hyaia. Debe notificarnos por escrito si disputa alguna parte de cualquier tarifa pagada o pagadera por usted. Bajo este acuerdo.",
      paragraph_6:
        "Debe proporcionarnos dicha notificación por escrito dentro de los sesenta (60) días posteriores a la tarifa aplicable y trabajaremos con usted para resolver la disputa aplicable de inmediato.",
      paragraph_7:
        "Si no nos proporciona este aviso por escrito de su disputa de tarifas dentro de este período, no tendrá derecho a disputar las tarifas pagadas o pagaderas por usted.",
      paragraph_8:
        "Si su uso de nuestros Servicios excede los montos prepagados por usted o si no paga los montos adeudados por usted, podemos suspender nuestros Servicios asociados con su cuenta sin previo aviso.",
      paragraph_9:
        "No seremos responsables de ningún daño, responsabilidad, pérdida (incluida la pérdida de datos o ganancias) o cualquier otra consecuencia en la que pueda incurrir en relación con la suspensión de nuestros servicios en virtud de esta sección.",
      paragraph_10:
        "Si las tarifas de servicio no se pagan de manera oportuna o si no podemos procesar su transacción utilizando la información de la tarjeta de crédito proporcionada o utilizando un método de pago alternativo, nos reservamos el derecho de revocar el acceso a su cuenta o degradar su cuenta a una libre. cuenta que puede resultar en la pérdida de datos y/o recursos.",
    },
    copyrigth_section: {
      title: "COPYRIGHT Y PROPIEDAD",
      paragraph_1:
        "Hyaia posee los derechos de propiedad intelectual de todos los componentes protegidos del Servicio, incluidos, entre otros, el nombre del Servicio, el material gráfico y los elementos de la interfaz de usuario final contenidos en el Servicio, muchas de las funciones individuales y la documentación relacionada.",
      paragraph_2:
        "Agradecemos sus comentarios sobre nuestros servicios, sin embargo, al enviar sugerencias u otros comentarios sobre nuestros servicios (“Contribuciones” ), usted acepta que:",
      list: {
        item_1:
          "no tenemos ninguna obligación de confidencialidad en relación con sus Envíos;",
        item_2:
          "podemos usar o divulgar (o elegir no usar o divulgar) sus Contribuciones para cualquier propósito y en cualquier forma;",
        item_3:
          "usted nos otorga derechos irrevocables y no exclusivos para explotar sus Contribuciones;",
        item_4:
          "usted no tiene derecho a ninguna compensación o reembolso de ningún tipo de nuestra parte bajo ninguna circunstancia por sus Contribuciones.",
      },
      paragraph_3:
        "No puede copiar, modificar, adaptar, reproducir, distribuir, aplicar ingeniería inversa, descompilar o desensamblar ningún aspecto del Servicio.",
      paragraph_4:
        "Hyaia no reclama derechos de propiedad intelectual sobre el Contenido que usted envía o proporciona al Servicio.",
    },
    brands_section: {
      title: "MARCAS Y LOGOTIPOS",
      paragraph_1:
        "Sujeto a estos Términos, nos otorgamos mutuamente el derecho de usar y mostrar el nombre y el logotipo de cada uno (las Marcas del Licenciante) en nuestros respectivos sitios web y en otros materiales promocionales únicamente en relación con cada una de nuestras respectivas actividades bajo estos Términos.",
      paragraph_2:
        "Todo uso de las Marcas del Licenciante se realizará de acuerdo con las pautas de uso aplicables de cada uno y garantizará el Beneficio del Licenciante.",
      paragraph_3:
        "Cualquiera de nosotros que use las Marcas del Licenciante del otro bajo esta subsección no usará, registrará ni tomará ninguna otra medida con respecto a ninguna de las Marcas del Licenciante, excepto en la medida en que lo permita previamente por escrito uno de nosotros cuyas Marcas del Licenciante se estén usando.",
      paragraph_4:
        "Al usar las Marcas del Licenciante en virtud de esta subsección, uno de nosotros que use las Marcas del Licenciante del otro siempre usará las Marcas del Licenciante actuales y no agregará, eliminará ni modificará ninguna de las Marcas del Licenciante.",
      paragraph_5:
        "Ninguno de los dos que use las Marcas del Licenciante de la otra persona puede, en ningún momento, tergiversar la relación entre nosotros.",
      paragraph_6:
        "Cualquiera que use las Marcas de licencia de otra persona no se representará a sí mismo como un afiliado u otro agente legal de uno de nosotros cuyas Marcas de licencia se estén usando.",
      paragraph_7:
        "Los derechos de uso y visualización de las Marcas del Licenciante de cada uno en virtud de esta sujeción terminarán automáticamente en caso de que estos Términos finalicen o si cualquiera de las partes solicita la eliminación del nombre y los logotipos de los sitios web o materiales promocionales.",
    },
    confidentiality_section: {
      title: "CONFIDENCIALIDAD",
      paragraph_1:
        "Información confidencial significa cualquier información o datos, ya sea en forma tangible o en forma tangible, revelados por cualquiera de las partes que estén marcados o designados como confidenciales o patentados o que de otro modo razonablemente podrían entenderse como confidenciales dada la naturaleza de la información y las circunstancias. publicidad circundante.",
      paragraph_2:
        "La “Información Confidencial” no incluye ninguna información que:",
      list: {
        item_1: "está disponible públicamente sin culpa de la parte receptora;",
        item_2:
          "era debidamente conocido por la parte receptora, sin restricción, antes de la divulgación por parte de la parte reveladora;",
        item_3:
          "fue debidamente divulgada a la parte receptora, sin restricción, por otra persona sin violar los derechos de la parte reveladora;",
        item_4:
          "es desarrollado independientemente por la parte receptora sin uso o referencia a la información confidencial de la parte reveladora.",
      },
      paragraph_3:
        "Cada parte acuerda que utilizará la Información confidencial de la otra parte únicamente de acuerdo con las disposiciones de este Acuerdo, y no divulgará dicha información a terceros sin el consentimiento previo por escrito de la otra parte, excepto que se permita lo contrario en este documento.",
      paragraph_4:
        "Cada parte acuerda ejercer el debido cuidado en la protección de la Información Confidencial contra el uso y la divulgación no autorizados.",
      paragraph_5:
        "Cada parte puede divulgar la Información confidencial de la otra parte, en su totalidad o en parte, a sus empleados, agentes, inversionistas reales o potenciales y subcontratistas que tengan la necesidad de saber y estén legalmente obligados a mantener dicha información confidencial de acuerdo con los términos de este documento.",
      paragraph_6:
        "Cualquiera de las partes puede divulgar la Información confidencial de la otra parte según lo exija la ley, previa notificación por escrito a la otra parte (donde lo permita la ley), siempre que esa parte haga todos los esfuerzos razonables para minimizar dicha divulgación en la medida permitida por la ley aplicable.",
    },
    warranty_section: {
      title: "GARANTÍA LIMITADA / LIMITACIÓN DE RESPONSABILIDAD",
      paragraph_1:
        "Los Servicios se proporcionan “tal cual” y según estén disponibles. Hyaia no ofrece garantías expresas o implícitas de ningún tipo, incluidas, entre otras, garantías implícitas de comerciabilidad o idoneidad para un propósito particular.",
      paragraph_2:
        "Ninguna comunicación entre el cliente y Hyaia, escrita u oral, creará una garantía o alterará o restringirá de alguna manera cualquier renuncia de garantía o limitación de responsabilidad establecida en esta sección o en cualquier otra parte de este acuerdo.",
      paragraph_3:
        "En ningún caso, Hyaia será responsable por la pérdida de ganancias u otros daños indirectos, especiales, de cobertura, ejemplares, incidentales o consecuentes que surjan de o en relación con este acuerdo o el uso o la imposibilidad de usar el Servicio.",
      paragraph_4:
        "En ningún caso, la responsabilidad de Hyaia por daños, pérdidas o causas de acción, ya sea por contrato o agravio, en forma conjunta o por separado, excederá el monto total en dólares pagado por el cliente a Hyaia durante los doce (12) meses anteriores al supuesto daño o perjuicio.",
      paragraph_5:
        "Las limitaciones de responsabilidad descritas aquí y en la subsección (b) a continuación se aplican igualmente a la responsabilidad por negligencia:",
      list: {
        item_1:
          "Sin limitar la generalidad de lo anterior, Hyaia no será responsable de ningún reclamo o pérdida que resulte de violaciones de seguridad, exposición de datos confidenciales o privados (excepto en la medida en que la ley aplicable prohíba la limitación de dicha responsabilidad) o pérdida de datos o datos. acceso.",
        item_2:
          "Hyaia no es responsable de la exactitud, veracidad o validez de los datos ingresados ​​por el Cliente o proporcionados a través del Servicio.",
        item_3:
          "Hyaia no será responsable por interrupciones o retrasos en la transmisión del Servicio causados ​​por actos de Dios, terrorismo, fuego, agua, disturbios, actos de gobierno, actos u omisiones de proveedores de red troncal de Internet o cualquier otra causa fuera del control de Hyaia.",
        item_4:
          "El único y exclusivo recurso de el Cliente, si no está satisfecho con el Servicio o con los términos, condiciones, reglas, políticas, pautas y prácticas de Hyaia, debe interrumpir el uso del Servicio.",
        item_5:
          "El Cliente reconoce y acepta que Hyaia fijó sus precios y celebró este Acuerdo de acuerdo con las limitaciones y exclusiones de responsabilidad y renuncias de garantía establecidas en esta sección y en otras partes de este Acuerdo (colectivamente, las “Limitaciones” ) y que las limitaciones forman una base esencial del trato entre Hyaia y el Cliente. Las Limitaciones subsisten y se aplican incluso si los recursos del Cliente provistos en este Acuerdo no cumplen con su propósito esencial.",
      },
    },
    idemnity_section: {
      title: "INDEMNIDAD",
      paragraph_1:
        "El Cliente indemnizará y eximirá a Hyaia y sus afiliados, empleados, funcionarios, directores, agentes, licenciantes, sucesores y cesionarios de todos los daños y responsabilidades, incluidos, entre otros, los honorarios de abogados incurridos como resultado de:",
      list: {
        item_1:
          "el incumplimiento por parte del Cliente de sus obligaciones en virtud de este Acuerdo;",
        item_2: "Actos negligentes o intencionales del Cliente;",
        item_3:
          "Para la violación por parte del Cliente de los derechos de terceros relacionados con el uso o la operación del Servicio, incluidos, entre otros, los derechos de privacidad, otros derechos de propiedad, secretos comerciales, información de propiedad, marcas registradas, derechos de autor o patentes, otros derechos de propiedad intelectual y reclamos por difamación, difamación o prácticas comerciales desleales.",
      },
    },
    applicable_law_section: {
      title: "LEY APLICABLE",
      paragraph_1:
        "Este contrato se realiza con Hyaia SAS (registrada en Francia - RCS 503 458 499).",
      paragraph_2:
        "Estos Términos se regirán por las leyes de Francia, a menos que se acuerde expresamente lo contrario a través de un Acuerdo de Cliente.",
      paragraph_3:
        "Por la presente, acepta expresamente estar sujeto a las leyes exclusivas de Francia con el fin de resolver cualquier disputa relacionada con su acceso o uso del Servicio.",
      paragraph_4:
        "Cualquier pregunta relacionada con los Términos de uso debe dirigirse a support@hyaia.com.",
    },
    aggremment_section: {
      title: "ACUERDO DE ARBITRAJE",
      paragraph_1:
        "Antes de iniciar una acción legal formal, primero intente ponerse en contacto con nuestro Servicio de atención al cliente, ya que la mayoría de las disputas se pueden resolver de esta manera.",
      paragraph_2:
        "Si no podemos resolver nuestra disputa a través de nuestro Servicio de atención al cliente, usted o cualquiera de sus afiliados, por un lado, Hyaia y cualquiera de los afiliados de Hyaia, aceptan resolver cualquier disputa que surja de estos Términos o Avisos de privacidad, o en relación con nuestro Servicios mediante arbitraje vinculante en Francia o en cualquier otro lugar que ambos aceptemos.",
      paragraph_3:
        "Solo puede resolver disputas con nosotros de manera individual y no puede presentar un reclamo como demandante o miembro de una clase en una acción colectiva, consolidada o representativa. No se permite el arbitraje colectivo, las demandas colectivas, las demandas de abogados privados ni la consolidación con otros arbitrajes.",
    },
    original_terms_section: {
      title: "TÉRMINOS DE USO ORIGINALES",
      paragraph_1:
        "Este documento en español es gratuito para traducir y no se superpone con el Término original, utilizado solo con el propósito de apoyar la comprensión de nuestros clientes. Las preguntas sobre estos Términos deben dirigirse a support@hyaia.com.",
    },
  },

  mini_navbar: {
    contact_us_nav_text: "Entre en contacto        ",
    partners_nav_text: "SOCIOS        ",
    company_nav_text: "EMPRESA",
    contact_nav_text: "CONTACTO",
    schedule_demo_text: "Programar una demostración",
  },

  navbar: {
    produtos_menu: {
      title: "PRODUCTO",
      connectors: {
        title: "Dados & Conectores",
        conectors_link_text: "Conectores",
        datasources_link_test: "Data Sources",
        datamanagement_link_test: " Gestión de Datos",
        realdata_link_test: "Datos en Tiempo Real",
      },
      dashboards_and_reports: {
        title: "Dashboards & Relatórios",
        interactive_dashboard: {
          title: "Dashboards Interactivos",
        },
        mobile_dashboards: {
          title: "Dashboards Móviles",
        },

        dashboard_design: {
          title: "Dashboards de Diseño Ágiles y Fáciles",
        },
      },
      automation: {
        title: "Automação",
        publish_and_share: {
          title: "Publicar y Compartir",
        },

        scheduling: {
          title: "Programación y Alertas",
        },

        security_and_management: {
          title: "Gestión de Usuarios                    ",
        },

        advanced_security: {
          title: "Seguridad Avanzada                    ",
        },
      },
    },

    solutions: {
      title: "SOLUCIONES",
      sectors: {
        title: "Por Sector                ",
        retail_text: "Varejo",
        public_sector_text: " Sector Público                ",
        education_text: "Educación",
        industry_text: "Industria",
        telecom_text: "Telecomunicaciones",
        health_text: "Salud",
        financial_text: "Financiero",
        ecommerce_text: "E-commerce",

        title_2: "Por Datos",
        database_text: " Base de Datos",
        financials_operational:
          "Cadenas Financieras y Operativas                ",
      },
    },

    examples: {
      title: "EJEMPLOS",
    },

    awards: {
      title: "PREMIOS",
    },

    modules: {
      title: "MÓDULOS",
    },
    suport: {
      title: "SUPORTE",
      options: {
        faq_text: "FAQ",
        ticket_text: "Asistencia en Línea y Tickets de Soporte",
        chat_text: "Chat Integrado con Nuestros Expertos",
        integrations_text: "API de Integración",
      },
    },
  },

  cookie_consent: {
    section_text_1: `Utilizamos cookies en nuestro sitio web para ofrecerle la experiencia más relevante recordando sus preferencias de visitas. Al hacer clic en "Aceptar", usted acepta el uso de TODAS las cookies.`,
    button_text: "ACEPTAR",
  },

  request_a_demo: {
    title: "LLENE EL FORMULARIO A CONTINUACIÓN, NOS CONTACTAREMOS CON USTED:",
    placeholders: {
      name_placeholder_text: "NOMBRE COMPLETO:            ",
      phone_placeholder_text: "TELÉFONO:            ",
      company_placeholder_text: "EMPRESA:           ",
      comments_placeholder_text: "MENSAJE:          ",
    },
    messageSucess: {
      sucess: "Mensaje enviado correctamente:",
      validation_error_text: "Error: Los campos no pueden estar en blanco"
    },
  },

  footer: {
    change_language: "Cambiar Idioma        ",
    social_media: {
      follow_us_text: "Acompañhe nossas redes sociales:            ",
    },
    suport_and_services: {
      title: "SERVICIOS Y RECURSOS            ",
      partners_text: "Parceiros",
      data_connection_text: "Conexión de Dados            ",
    },
    privacy_and_terms: {
      privacy_policy: "Política de Privacidad",
      terms_of_use: "Términos de Uso",
    },
  },
};

const translation = { translations: SPANISH_TRANSLATION };

export default translation;
